import { InjectionToken, Injectable, Optional, Inject, NgModule, SkipSelf } from '@angular/core';
import { HttpUrlEncodingCodec, HttpHeaders, HttpParams, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';

/**
 * CustomHttpUrlEncodingCodec
 * Fix plus sign (+) not encoding, so sent as blank space
 * See: https://github.com/angular/angular/issues/11058#issuecomment-247367318
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class CustomHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
    encodeKey(k) {
        k = super.encodeKey(k);
        return k.replace(/\+/gi, '%2B');
    }
    encodeValue(v) {
        v = super.encodeValue(v);
        return v.replace(/\+/gi, '%2B');
    }
}

const API_HANDLER = new InjectionToken('apiHandler');
const BASE_PATH = new InjectionToken('basePath');
const VERSION = new InjectionToken('version');
const COLLECTION_FORMATS = {
    csv: ',',
    tsv: '   ',
    ssv: ' ',
    pipe: '|',
};

class Configuration {
    constructor(configurationParameters = {}) {
        this.apiKeys = configurationParameters.apiKeys;
        this.username = configurationParameters.username;
        this.password = configurationParameters.password;
        this.accessToken = configurationParameters.accessToken;
        this.basePath = configurationParameters.basePath;
        this.withCredentials = configurationParameters.withCredentials;
        this.version = configurationParameters.version;
    }
    /**
     * Select the correct content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param contentTypes - the array of content types that are available for selection
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    selectHeaderContentType(contentTypes) {
        if (contentTypes.length == 0) {
            return undefined;
        }
        let type = contentTypes.find((x) => this.isJsonMime(x));
        if (type === undefined) {
            return contentTypes[0];
        }
        return type;
    }
    /**
     * Select the correct accept content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct accept content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param accepts - the array of content types that are available for selection.
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    selectHeaderAccept(accepts) {
        if (accepts.length == 0) {
            return undefined;
        }
        let type = accepts.find((x) => this.isJsonMime(x));
        if (type === undefined) {
            return accepts[0];
        }
        return type;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    isJsonMime(mime) {
        const jsonMime = new RegExp('^(application/json|[^;/ \t]+/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return (mime != null &&
            (jsonMime.test(mime) ||
                mime.toLowerCase() === 'application/json-patch+json'));
    }
}

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class AgenciesService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteAgency(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/agencies/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAgencies(page, page_size, name_contains, content_type, status, import_type, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (name_contains !== undefined && name_contains !== null) {
            queryParameters = queryParameters.set('name_contains', name_contains);
        }
        if (content_type !== undefined && content_type !== null) {
            queryParameters = queryParameters.set('content_type', content_type);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', status);
        }
        if (import_type !== undefined && import_type !== null) {
            queryParameters = queryParameters.set('import_type', import_type);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/agencies`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAgency(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetAgency.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/agencies/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostAgencies(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/agencies`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPutAgency(id, body, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsPutAgency.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/agencies/${encodeURIComponent(String(id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
AgenciesService.ɵfac = function AgenciesService_Factory(t) { return new (t || AgenciesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
AgenciesService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AgenciesService, factory: AgenciesService.ɵfac });
AgenciesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AgenciesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class AuthorsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsPostAuthor(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/authors`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
AuthorsService.ɵfac = function AuthorsService_Factory(t) { return new (t || AuthorsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
AuthorsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthorsService, factory: AuthorsService.ɵfac });
AuthorsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthorsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class AutocompleteService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsGetAutocompleteAgenciesByName(title, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteAgenciesByName.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/agencies_by_name`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteAgencyGroupsByName(title, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteAgencyGroupsByName.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/agency_groups_by_name`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteAuthorsByName(title, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteAuthorsByName.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/authors_by_name`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteCategoriesByTitle(title, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteCategoriesByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/categories_by_title`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteCompaniesByTitle(query, observe = 'body', reportProgress = false) {
        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling cmsGetAutocompleteCompaniesByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', query);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/companies_by_name`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteContractsByName(name, observe = 'body', reportProgress = false) {
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling cmsGetAutocompleteContractsByName.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', name);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/contracts_by_name`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteCountryByTitle(title, language, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteCountryByTitle.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling cmsGetAutocompleteCountryByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        if (language !== undefined && language !== null) {
            queryParameters = queryParameters.set('language', language);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/country_by_title`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteCurrencyByTitle(title, language, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteCurrencyByTitle.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling cmsGetAutocompleteCurrencyByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        if (language !== undefined && language !== null) {
            queryParameters = queryParameters.set('language', language);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/currency_by_title`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteGalleriesByTitle(query, observe = 'body', reportProgress = false) {
        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling cmsGetAutocompleteGalleriesByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', query);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/galleries_by_title`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteKeywordsByTitle(title, language, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteKeywordsByTitle.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling cmsGetAutocompleteKeywordsByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        if (language !== undefined && language !== null) {
            queryParameters = queryParameters.set('language', language);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/keywords_by_title`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompletePeopleByName(query, observe = 'body', reportProgress = false) {
        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling cmsGetAutocompletePeopleByName.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', query);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/people_by_names`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteSpecialOfferTypesByName(title, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteSpecialOfferTypesByName.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/special_offer_types_by_name`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteTagsByTitle(title, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteTagsByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/tags_by_title`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteDynamicDocument(modelType, searchField, title, idField, titleField, observe = 'body', reportProgress = false) {
        if (modelType === null || modelType === undefined) {
            throw new Error('Required parameter modelType was null or undefined when calling cmsGetAutocompleteDynamicDocument.');
        }
        if (searchField === null || searchField === undefined) {
            throw new Error('Required parameter searchField was null or undefined when calling cmsGetAutocompleteDynamicDocument.');
        }
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteDynamicDocument.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        if (idField !== undefined && idField !== null) {
            queryParameters = queryParameters.set('id_field', idField);
        }
        if (titleField !== undefined && titleField !== null) {
            queryParameters = queryParameters.set('title_field', titleField);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/${encodeURIComponent(modelType)}/${encodeURIComponent(searchField)}`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteUserGroupByTitle(title, language, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling cmsGetAutocompleteUserGroupByTitle.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling cmsGetAutocompleteUserGroupByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        if (language !== undefined && language !== null) {
            queryParameters = queryParameters.set('language', language);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/user_group_by_title`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetAutocompleteUsersByName(query, observe = 'body', reportProgress = false) {
        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling cmsGetAutocompleteUsersByName.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', query);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/autocomplete/users_by_name`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetAutocompleteAuthorsByName(title, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling frontGetAutocompleteAuthorsByName.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/autocomplete/authors_by_name`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetAutocompleteCountryByTitle(title, language, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling frontGetAutocompleteCountryByTitle.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling frontGetAutocompleteCountryByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        if (language !== undefined && language !== null) {
            queryParameters = queryParameters.set('language', language);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/autocomplete/country_by_title`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetAutocompleteCurrencyByTitle(title, language, observe = 'body', reportProgress = false) {
        if (title === null || title === undefined) {
            throw new Error('Required parameter title was null or undefined when calling frontGetAutocompleteCurrencyByTitle.');
        }
        if (language === null || language === undefined) {
            throw new Error('Required parameter language was null or undefined when calling frontGetAutocompleteCurrencyByTitle.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (title !== undefined && title !== null) {
            queryParameters = queryParameters.set('title', title);
        }
        if (language !== undefined && language !== null) {
            queryParameters = queryParameters.set('language', language);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/autocomplete/currency_by_title`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
AutocompleteService.ɵfac = function AutocompleteService_Factory(t) { return new (t || AutocompleteService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
AutocompleteService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AutocompleteService, factory: AutocompleteService.ɵfac });
AutocompleteService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutocompleteService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class CMSService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsCancelFinanceInvoice(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-invoices/invoices/cancel`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsChangeFinanceInvoiceStatus(invoiceId, body, observe = 'body', reportProgress = false) {
        if (invoiceId === null || invoiceId === undefined) {
            throw new Error('Required parameter invoiceId was null or undefined when calling cmsChangeFinanceInvoiceStatus.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-invoices/invoices/${encodeURIComponent(String(invoiceId))}/status`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsChangeFinanceInvoiceStatusMass(invoiceId, body, observe = 'body', reportProgress = false) {
        if (invoiceId === null || invoiceId === undefined) {
            throw new Error('Required parameter invoiceId was null or undefined when calling cmsChangeFinanceInvoiceStatusMass.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-invoices/invoices/${encodeURIComponent(String(invoiceId))}/status_mass`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsDeleteDownload(download_id, observe = 'body', reportProgress = false) {
        if (download_id === null || download_id === undefined) {
            throw new Error('Required parameter download_id was null or undefined when calling cmsDeleteDownload.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/cms/downloads/${encodeURIComponent(String(download_id))}/delete`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
            responseType: 'blob',
        });
    }
    cmsDeleteFinanceInvoice(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-invoices/invoices/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsDeleteFinanceInvoiceLine(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsDeleteFinanceInvoiceLine.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('delete', `${this.basePath}/cms/finance-invoices/invoice-line/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsDeleteInvoiceStaticContent(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-administration/invoice-static-contents/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsEditFinanceInvoiceLine(id, body, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsEditFinanceInvoiceLine.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/finance-invoices/invoice-line/${encodeURIComponent(String(id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
            responseType: 'blob',
        });
    }
    cmsExportDownloads(page, page_size, date_from, date_to, company, product_name, content_type, user_type, user_id, user_name, author_id, author_name, agency_id, agency_name, variation, above_price, below_price, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (date_from !== undefined && date_from !== null) {
            queryParameters = queryParameters.set('date_from', date_from);
        }
        if (date_to !== undefined && date_to !== null) {
            queryParameters = queryParameters.set('date_to', date_to);
        }
        if (company !== undefined && company !== null) {
            queryParameters = queryParameters.set('company', company);
        }
        if (product_name !== undefined && product_name !== null) {
            queryParameters = queryParameters.set('product_name', product_name);
        }
        if (content_type !== undefined && content_type !== null) {
            queryParameters = queryParameters.set('content_type', content_type);
        }
        if (user_type !== undefined && user_type !== null) {
            queryParameters = queryParameters.set('user_type', user_type);
        }
        if (user_id !== undefined && user_id !== null) {
            queryParameters = queryParameters.set('user_id', user_id);
        }
        if (user_name !== undefined && user_name !== null) {
            queryParameters = queryParameters.set('user_name', user_name);
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (author_name !== undefined && author_name !== null) {
            queryParameters = queryParameters.set('author_name', author_name);
        }
        if (agency_id !== undefined && agency_id !== null) {
            queryParameters = queryParameters.set('agency_id', agency_id);
        }
        if (agency_name !== undefined && agency_name !== null) {
            queryParameters = queryParameters.set('agency_name', agency_name);
        }
        if (variation !== undefined && variation !== null) {
            queryParameters = queryParameters.set('variation', variation);
        }
        if (above_price !== undefined && above_price !== null) {
            queryParameters = queryParameters.set('above_price', above_price);
        }
        if (below_price !== undefined && below_price !== null) {
            queryParameters = queryParameters.set('below_price', below_price);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/octet-stream'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/downloads/export`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
            responseType: 'blob',
        });
    }
    cmsFinanceInvoice(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsFinanceInvoice.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-invoices/invoice/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsFiscalizeFinanceInvoice(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-invoices/invoices/fiscalize`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGalleriesDisablePixsellAutoPublish(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('delete', `${this.basePath}/cms/galleries/pixsell-auto-publish`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGalleriesEnablePixsellAutoPublish(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/cms/galleries/pixsell-auto-publish`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGalleriesGetPixsellAutoPublish(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/galleries/pixsell-auto-publish`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetCompanies(page, page_size, from_date, to_date, company_name, oib, company_id, address, contact_person, status, country, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (from_date !== undefined && from_date !== null) {
            queryParameters = queryParameters.set('from_date', from_date);
        }
        if (to_date !== undefined && to_date !== null) {
            queryParameters = queryParameters.set('to_date', to_date);
        }
        if (company_name !== undefined && company_name !== null) {
            queryParameters = queryParameters.set('company_name', company_name);
        }
        if (oib !== undefined && oib !== null) {
            queryParameters = queryParameters.set('oib', oib);
        }
        if (company_id !== undefined && company_id !== null) {
            queryParameters = queryParameters.set('company_id', company_id);
        }
        if (address !== undefined && address !== null) {
            queryParameters = queryParameters.set('address', address);
        }
        if (contact_person !== undefined && contact_person !== null) {
            queryParameters = queryParameters.set('contact_person', contact_person);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', status);
        }
        if (country !== undefined && country !== null) {
            queryParameters = queryParameters.set('country', country);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/companies`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetCompanyDownloads(company_id, page, page_size, date_from, date_to, user, variation, content_type, name, price, notice, observe = 'body', reportProgress = false) {
        if (company_id === null || company_id === undefined) {
            throw new Error('Required parameter company_id was null or undefined when calling cmsGetCompanyDownloads.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (date_from !== undefined && date_from !== null) {
            queryParameters = queryParameters.set('date_from', date_from);
        }
        if (date_to !== undefined && date_to !== null) {
            queryParameters = queryParameters.set('date_to', date_to);
        }
        if (user !== undefined && user !== null) {
            queryParameters = queryParameters.set('user', user);
        }
        if (variation !== undefined && variation !== null) {
            queryParameters = queryParameters.set('variation', variation);
        }
        if (content_type !== undefined && content_type !== null) {
            queryParameters = queryParameters.set('content_type', content_type);
        }
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', name);
        }
        if (price !== undefined && price !== null) {
            queryParameters = queryParameters.set('price', price);
        }
        if (notice !== undefined && notice !== null) {
            queryParameters = queryParameters.set('notice', notice);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/companies/${encodeURIComponent(String(company_id))}/downloads`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetCompanyInvoices(company_id, page, page_size, date_from, date_to, invoice_number, status, observe = 'body', reportProgress = false) {
        if (company_id === null || company_id === undefined) {
            throw new Error('Required parameter company_id was null or undefined when calling cmsGetCompanyInvoices.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (date_from !== undefined && date_from !== null) {
            queryParameters = queryParameters.set('date_from', date_from);
        }
        if (date_to !== undefined && date_to !== null) {
            queryParameters = queryParameters.set('date_to', date_to);
        }
        if (invoice_number !== undefined && invoice_number !== null) {
            queryParameters = queryParameters.set('invoice_number', invoice_number);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', status);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/companies/${encodeURIComponent(String(company_id))}/invoices`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetCompanyUsers(company_id, page, page_size, first_name, last_name, email, user_id, user_rights, account_status, observe = 'body', reportProgress = false) {
        if (company_id === null || company_id === undefined) {
            throw new Error('Required parameter company_id was null or undefined when calling cmsGetCompanyUsers.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (first_name !== undefined && first_name !== null) {
            queryParameters = queryParameters.set('first_name', first_name);
        }
        if (last_name !== undefined && last_name !== null) {
            queryParameters = queryParameters.set('last_name', last_name);
        }
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', email);
        }
        if (user_id !== undefined && user_id !== null) {
            queryParameters = queryParameters.set('user_id', user_id);
        }
        if (user_rights !== undefined && user_rights !== null) {
            queryParameters = queryParameters.set('user_rights', user_rights);
        }
        if (account_status !== undefined && account_status !== null) {
            queryParameters = queryParameters.set('account_status', account_status);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/companies/${encodeURIComponent(String(company_id))}/users`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetDownload(download_id, observe = 'body', reportProgress = false) {
        if (download_id === null || download_id === undefined) {
            throw new Error('Required parameter download_id was null or undefined when calling cmsGetDownload.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/downloads/${encodeURIComponent(String(download_id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetDownloadIptc(downloadId, observe = 'body', reportProgress = false) {
        if (downloadId === null || downloadId === undefined) {
            throw new Error('Required parameter downloadId was null or undefined when calling cmsGetDownloadIptc.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/downloads/${encodeURIComponent(String(downloadId))}/iptc`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetDownloads(page, page_size, date_from, date_to, company, product_name, content_type, user_type, user_id, user_name, author_id, author_name, agency_id, agency_name, variation, above_price, below_price, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (date_from !== undefined && date_from !== null) {
            queryParameters = queryParameters.set('date_from', date_from);
        }
        if (date_to !== undefined && date_to !== null) {
            queryParameters = queryParameters.set('date_to', date_to);
        }
        if (company !== undefined && company !== null) {
            queryParameters = queryParameters.set('company', company);
        }
        if (product_name !== undefined && product_name !== null) {
            queryParameters = queryParameters.set('product_name', product_name);
        }
        if (content_type !== undefined && content_type !== null) {
            queryParameters = queryParameters.set('content_type', content_type);
        }
        if (user_type !== undefined && user_type !== null) {
            queryParameters = queryParameters.set('user_type', user_type);
        }
        if (user_id !== undefined && user_id !== null) {
            queryParameters = queryParameters.set('user_id', user_id);
        }
        if (user_name !== undefined && user_name !== null) {
            queryParameters = queryParameters.set('user_name', user_name);
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (author_name !== undefined && author_name !== null) {
            queryParameters = queryParameters.set('author_name', author_name);
        }
        if (agency_id !== undefined && agency_id !== null) {
            queryParameters = queryParameters.set('agency_id', agency_id);
        }
        if (agency_name !== undefined && agency_name !== null) {
            queryParameters = queryParameters.set('agency_name', agency_name);
        }
        if (variation !== undefined && variation !== null) {
            queryParameters = queryParameters.set('variation', variation);
        }
        if (above_price !== undefined && above_price !== null) {
            queryParameters = queryParameters.set('above_price', above_price);
        }
        if (below_price !== undefined && below_price !== null) {
            queryParameters = queryParameters.set('below_price', below_price);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/downloads`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetFinanceAdministartionItemItem(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetFinanceAdministartionItemItem.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-administration/items/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetFinanceAdministrationItems(page, page_size, sort, contract_type, content_type, agency_name, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', sort);
        }
        if (contract_type !== undefined && contract_type !== null) {
            queryParameters = queryParameters.set('contract_type', contract_type);
        }
        if (content_type !== undefined && content_type !== null) {
            queryParameters = queryParameters.set('content_type', content_type);
        }
        if (agency_name !== undefined && agency_name !== null) {
            queryParameters = queryParameters.set('agency_name', agency_name);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-administration/items`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetFinanceCalculations(page, page_size, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-administration/calculations`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetFinanceInvoiceList(page, page_size, date_from, date_to, invoice_number, company, invoice_type, payment_method, status, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (date_from !== undefined && date_from !== null) {
            queryParameters = queryParameters.set('date_from', date_from);
        }
        if (date_to !== undefined && date_to !== null) {
            queryParameters = queryParameters.set('date_to', date_to);
        }
        if (invoice_number !== undefined && invoice_number !== null) {
            queryParameters = queryParameters.set('invoice_number', invoice_number);
        }
        if (company !== undefined && company !== null) {
            queryParameters = queryParameters.set('company', company);
        }
        if (invoice_type !== undefined && invoice_type !== null) {
            queryParameters = queryParameters.set('invoice_type', invoice_type);
        }
        if (payment_method !== undefined && payment_method !== null) {
            queryParameters = queryParameters.set('payment_method', payment_method);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', status);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-invoices/invoices`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetFinanceInvoicePDF(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/pdf'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/pdf'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-invoices/invoices/pdf`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
            responseType: 'blob',
        });
    }
    cmsGetFinanceInvoiceSapJournalEntry(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['text/plain'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-invoices/invoices/sap-journal-entry`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
            responseType: 'blob',
        });
    }
    cmsGetFinanceInvoiceSapJournalEntryCount(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-invoices/invoices/sap-journal-entry/count`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetInvoiceStaticContentItem(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetInvoiceStaticContentItem.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-administration/invoice-static-contents/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetInvoices(page, page_size, date_from, date_to, invoice_number, status, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (date_from !== undefined && date_from !== null) {
            queryParameters = queryParameters.set('date_from', date_from);
        }
        if (date_to !== undefined && date_to !== null) {
            queryParameters = queryParameters.set('date_to', date_to);
        }
        if (invoice_number !== undefined && invoice_number !== null) {
            queryParameters = queryParameters.set('invoice_number', invoice_number);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', status);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/invoices`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetInvoieStaticContents(page, page_size, name, code, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', name);
        }
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', code);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-administration/invoice-static-contents`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetSapTaxIndicatorItem(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetSapTaxIndicatorItem.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-administration/sap_tax_indicators/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetSapTaxIndicatorsList(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-administration/sap_tax_indicators`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetUsers(page, page_size, from_date, to_date, first_name, last_name, company, username, email, user_type, status, download_rights, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (from_date !== undefined && from_date !== null) {
            queryParameters = queryParameters.set('from_date', from_date);
        }
        if (to_date !== undefined && to_date !== null) {
            queryParameters = queryParameters.set('to_date', to_date);
        }
        if (first_name !== undefined && first_name !== null) {
            queryParameters = queryParameters.set('first_name', first_name);
        }
        if (last_name !== undefined && last_name !== null) {
            queryParameters = queryParameters.set('last_name', last_name);
        }
        if (company !== undefined && company !== null) {
            queryParameters = queryParameters.set('company', company);
        }
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', username);
        }
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', email);
        }
        if (user_type !== undefined && user_type !== null) {
            queryParameters = queryParameters.set('user_type', user_type);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', status);
        }
        if (download_rights !== undefined && download_rights !== null) {
            queryParameters = queryParameters.set('download_rights', download_rights);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/users`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostFinanceAdministrationItem(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-administration/items`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostFinanceCalculation(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-administration/calculations`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostInvoiceStaticContent(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-administration/invoice-static-contents`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostSapTaxIndicator(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/finance-administration/sap_tax_indicators`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsResumeB2C(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('delete', `${this.basePath}/cms/finance-administration/suspend-b2c`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsSaveDownload(download_id, body, observe = 'body', reportProgress = false) {
        if (download_id === null || download_id === undefined) {
            throw new Error('Required parameter download_id was null or undefined when calling cmsSaveDownload.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/downloads/${encodeURIComponent(String(download_id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsSaveFinanceAdministartionItemItem(id, body, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsSaveFinanceAdministartionItemItem.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/finance-administration/items/${encodeURIComponent(String(id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsSaveInvoiceStaticContentItem(id, body, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsSaveInvoiceStaticContentItem.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/finance-administration/invoice-static-contents/${encodeURIComponent(String(id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsSaveSapTaxIndicatorItem(id, body, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsSaveSapTaxIndicatorItem.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/finance-administration/sap_tax_indicators/${encodeURIComponent(String(id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
            responseType: 'blob',
        });
    }
    cmsSuspendB2C(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/cms/finance-administration/suspend-b2c`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsSuspendB2CStatus(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/finance-administration/suspend-b2c`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
CMSService.ɵfac = function CMSService_Factory(t) { return new (t || CMSService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
CMSService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CMSService, factory: CMSService.ɵfac });
CMSService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CMSService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class CMSCompaniesService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsCreateCompany(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/companies`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetCompany(company_id, observe = 'body', reportProgress = false) {
        if (company_id === null || company_id === undefined) {
            throw new Error('Required parameter company_id was null or undefined when calling cmsGetCompany.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/companies/${encodeURIComponent(String(company_id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsUpdateCompany(company_id, body, observe = 'body', reportProgress = false) {
        if (company_id === null || company_id === undefined) {
            throw new Error('Required parameter company_id was null or undefined when calling cmsUpdateCompany.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/companies/${encodeURIComponent(String(company_id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
CMSCompaniesService.ɵfac = function CMSCompaniesService_Factory(t) { return new (t || CMSCompaniesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
CMSCompaniesService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CMSCompaniesService, factory: CMSCompaniesService.ɵfac });
CMSCompaniesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CMSCompaniesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class CMSContractsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsCreateCompanyContract(company_id, body, observe = 'body', reportProgress = false) {
        if (company_id === null || company_id === undefined) {
            throw new Error('Required parameter company_id was null or undefined when calling cmsCreateCompanyContract.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/companies/${encodeURIComponent(String(company_id))}/contracts`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetCompanyContracts(company_id, observe = 'body', reportProgress = false) {
        if (company_id === null || company_id === undefined) {
            throw new Error('Required parameter company_id was null or undefined when calling cmsGetCompanyContracts.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/companies/${encodeURIComponent(String(company_id))}/contracts`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetContracts(page, page_size, id, beginning_date, end_date, contract_name, status, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', id);
        }
        if (beginning_date !== undefined && beginning_date !== null) {
            queryParameters = queryParameters.set('beginning_date', beginning_date);
        }
        if (end_date !== undefined && end_date !== null) {
            queryParameters = queryParameters.set('end_date', end_date);
        }
        if (contract_name !== undefined && contract_name !== null) {
            queryParameters = queryParameters.set('contract_name', contract_name);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', status);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/contracts`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsUpdateCompanyContract(contract_id, body, observe = 'body', reportProgress = false) {
        if (contract_id === null || contract_id === undefined) {
            throw new Error('Required parameter contract_id was null or undefined when calling cmsUpdateCompanyContract.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/companies/contracts/${encodeURIComponent(String(contract_id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
CMSContractsService.ɵfac = function CMSContractsService_Factory(t) { return new (t || CMSContractsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
CMSContractsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CMSContractsService, factory: CMSContractsService.ɵfac });
CMSContractsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CMSContractsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class CMSGalleriesService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsCombineGalleries(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/galleries/combine`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsDeleteGalleries(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/galleries/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetGalleries(page, page_size, query, query_include_headline, query_include_people, query_include_caption, query_include_keywords, from_date, to_date, product_status, has_article, agency_id, category_id, gallery_id, by_operator_id, did_send_newsletter_push, marked_for_translation, is_translated, tag_id, is_special_offer, upload_channel, article_title, article_author_id, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', query);
        }
        if (query_include_headline !== undefined &&
            query_include_headline !== null) {
            queryParameters = queryParameters.set('query_include_headline', query_include_headline);
        }
        if (query_include_people !== undefined && query_include_people !== null) {
            queryParameters = queryParameters.set('query_include_people', query_include_people);
        }
        if (query_include_caption !== undefined && query_include_caption !== null) {
            queryParameters = queryParameters.set('query_include_caption', query_include_caption);
        }
        if (query_include_keywords !== undefined &&
            query_include_keywords !== null) {
            queryParameters = queryParameters.set('query_include_keywords', query_include_keywords);
        }
        if (from_date !== undefined && from_date !== null) {
            queryParameters = queryParameters.set('from_date', from_date);
        }
        if (to_date !== undefined && to_date !== null) {
            queryParameters = queryParameters.set('to_date', to_date);
        }
        if (product_status !== undefined && product_status !== null) {
            queryParameters = queryParameters.set('product_status', product_status);
        }
        if (has_article !== undefined && has_article !== null) {
            queryParameters = queryParameters.set('has_article', has_article);
        }
        if (agency_id !== undefined && agency_id !== null) {
            queryParameters = queryParameters.set('agency_id', agency_id);
        }
        if (category_id !== undefined && category_id !== null) {
            queryParameters = queryParameters.set('category_id', category_id);
        }
        if (gallery_id !== undefined && gallery_id !== null) {
            queryParameters = queryParameters.set('gallery_id', gallery_id);
        }
        if (by_operator_id !== undefined && by_operator_id !== null) {
            queryParameters = queryParameters.set('by_operator_id', by_operator_id);
        }
        if (did_send_newsletter_push !== undefined &&
            did_send_newsletter_push !== null) {
            queryParameters = queryParameters.set('did_send_newsletter_push', did_send_newsletter_push);
        }
        if (marked_for_translation !== undefined &&
            marked_for_translation !== null) {
            queryParameters = queryParameters.set('marked_for_translation', marked_for_translation);
        }
        if (is_translated !== undefined && is_translated !== null) {
            queryParameters = queryParameters.set('is_translated', is_translated);
        }
        if (tag_id !== undefined && tag_id !== null) {
            queryParameters = queryParameters.set('tag_id', tag_id);
        }
        if (is_special_offer !== undefined && is_special_offer !== null) {
            queryParameters = queryParameters.set('is_special_offer', is_special_offer);
        }
        if (upload_channel !== undefined && upload_channel !== null) {
            queryParameters = queryParameters.set('upload_channel', upload_channel);
        }
        if (article_title !== undefined && article_title !== null) {
            queryParameters = queryParameters.set('article_title', article_title);
        }
        if (article_author_id !== undefined && article_author_id !== null) {
            queryParameters = queryParameters.set('article_author_id', article_author_id);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/galleries`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetGallery(id_or_seo, is_legacy_url, source, observe = 'body', reportProgress = false) {
        if (id_or_seo === null || id_or_seo === undefined) {
            throw new Error('Required parameter id_or_seo was null or undefined when calling cmsGetGallery.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (is_legacy_url !== undefined && is_legacy_url !== null) {
            queryParameters = queryParameters.set('is_legacy_url', is_legacy_url);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/galleries/${encodeURIComponent(String(id_or_seo))}`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostGallery(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/galleries`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsUpdateGallery(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/galleries`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
CMSGalleriesService.ɵfac = function CMSGalleriesService_Factory(t) { return new (t || CMSGalleriesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
CMSGalleriesService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CMSGalleriesService, factory: CMSGalleriesService.ɵfac });
CMSGalleriesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CMSGalleriesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class CMSUsersService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteUser2(user_id, observe = 'body', reportProgress = false) {
        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling cmsDeleteUser2.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('delete', `${this.basePath}/cms/user/${encodeURIComponent(String(user_id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetUser2(user_id, observe = 'body', reportProgress = false) {
        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling cmsGetUser2.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/user/${encodeURIComponent(String(user_id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostUser2(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/user`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPutUser2(user_id, body, observe = 'body', reportProgress = false) {
        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling cmsPutUser2.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/user/${encodeURIComponent(String(user_id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsRestoreUser2(user_id, observe = 'body', reportProgress = false) {
        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling cmsRestoreUser2.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/cms/user/restore/${encodeURIComponent(String(user_id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
CMSUsersService.ɵfac = function CMSUsersService_Factory(t) { return new (t || CMSUsersService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
CMSUsersService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CMSUsersService, factory: CMSUsersService.ɵfac });
CMSUsersService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CMSUsersService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class CartService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    frontAddCartLine(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cart/lines`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontCreateCartPayment(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cart/payment`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontDeleteCartLineItems(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cart/lines/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontDownloadCartZip(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/zip'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cart/download`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
            responseType: 'blob',
        });
    }
    frontFinalizeCartPayment(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cart/finalize`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetCart(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cart`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontUpdateCartLine(cartLineId, body, observe = 'body', reportProgress = false) {
        if (cartLineId === null || cartLineId === undefined) {
            throw new Error('Required parameter cartLineId was null or undefined when calling frontUpdateCartLine.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cart/lines/${encodeURIComponent(String(cartLineId))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
CartService.ɵfac = function CartService_Factory(t) { return new (t || CartService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
CartService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CartService, factory: CartService.ɵfac });
CartService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CartService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class CategoriesService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteCategory(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/categories/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetCategory(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/categories`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostCategory(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/categories`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetCategory(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/categories`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
CategoriesService.ɵfac = function CategoriesService_Factory(t) { return new (t || CategoriesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
CategoriesService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CategoriesService, factory: CategoriesService.ɵfac });
CategoriesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CategoriesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class DynamicViewsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsGetDynamicViews(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/dynamic_views`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetViewCreate(viewId, body, observe = 'body', reportProgress = false) {
        if (viewId === null || viewId === undefined) {
            throw new Error('Required parameter viewId was null or undefined when calling cmsGetViewCreate.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (viewId !== undefined && viewId !== null) {
            queryParameters = queryParameters.set('viewId', viewId);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/dynamic_views/${viewId}/show/`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetViewDelete(viewId, id, observe = 'body', reportProgress = false) {
        if (viewId === null || viewId === undefined) {
            throw new Error('Required parameter viewId was null or undefined when calling cmsGetViewDelete.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetViewDelete.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (viewId !== undefined && viewId !== null) {
            queryParameters = queryParameters.set('viewId', viewId);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', id);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('delete', `${this.basePath}/cms/dynamic_views/${viewId}/show/${id}`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetViewIndex(viewId, body, observe = 'body', reportProgress = false) {
        if (viewId === null || viewId === undefined) {
            throw new Error('Required parameter viewId was null or undefined when calling cmsGetViewIndex.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (viewId !== undefined && viewId !== null) {
            //queryParameters = queryParameters.set('viewId', <any>viewId);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/dynamic_views/${viewId}/index`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetViewShow(viewId, id, body, observe = 'body', reportProgress = false) {
        if (viewId === null || viewId === undefined) {
            throw new Error('Required parameter viewId was null or undefined when calling cmsGetViewShow.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetViewShow.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (viewId !== undefined && viewId !== null) {
            //queryParameters = queryParameters.set('viewId', <any>viewId);
        }
        if (id !== undefined && id !== null) {
            //queryParameters = queryParameters.set('id', <any>id);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('get', `${this.basePath}/cms/dynamic_views/${viewId}/show/${id}`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetViewUpdate(viewId, id, body, observe = 'body', reportProgress = false) {
        if (viewId === null || viewId === undefined) {
            throw new Error('Required parameter viewId was null or undefined when calling cmsGetViewUpdate.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetViewUpdate.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (viewId !== undefined && viewId !== null) {
            //queryParameters = queryParameters.set('viewId', <any>viewId);
        }
        if (id !== undefined && id !== null) {
            //queryParameters = queryParameters.set('id', <any>id);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/dynamic_views/${viewId}/show/${id}`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsExecuteDynamicViewAction(viewId, actionId, formData, observe = 'body', reportProgress = false) {
        if (viewId === null || viewId === undefined) {
            throw new Error('Required parameter viewId was null or undefined when calling cmsExecuteDynamicViewAction.');
        }
        if (actionId === null || actionId === undefined) {
            throw new Error('Required parameter actionId was null or undefined when calling cmsExecuteDynamicViewAction.');
        }
        // Special case for export action
        if (actionId === 'export') {
            return this.cmsExecuteDynamicViewExportAction(viewId, formData);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // Check if formData is a FormData instance (has a file)
        let useFormData = formData instanceof FormData;
        // to determine the Content-Type header
        let contentTypeHeader;
        if (useFormData) {
            // For file uploads, we need to remove the Content-Type header to let the browser set it with boundary
            contentTypeHeader = '';
        }
        else {
            contentTypeHeader = 'application/json';
            headers = headers.set('Content-Type', contentTypeHeader);
            // Convert to JSON if not FormData
            formData = JSON.stringify(formData);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/dynamic_views/${viewId}/action/${actionId}`, {
            body: formData,
            headers: headers,
            withCredentials: this.configuration.withCredentials,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /**
     * Execute export action that returns a file download
     * @param viewId View ID
     * @param formData Data to send
     */
    cmsExecuteDynamicViewExportAction(viewId, formData) {
        if (viewId === null || viewId === undefined) {
            throw new Error('Required parameter viewId was null or undefined when calling cmsExecuteDynamicViewExportAction.');
        }
        let headers = this.defaultHeaders;
        // For file downloads, we set the responseType to 'blob'
        // and don't set an Accept header to take whatever the server sends
        // Convert to JSON if not FormData
        if (!(formData instanceof FormData)) {
            headers = headers.set('Content-Type', 'application/json');
            formData = JSON.stringify(formData);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/dynamic_views/${viewId}/action/export`, {
            body: formData,
            headers: headers,
            withCredentials: this.configuration.withCredentials,
            responseType: 'blob',
            observe: 'response',
        }).pipe(
        // Map the response to handle the file download
        map((response) => {
            const contentDisposition = response.headers.get('Content-Disposition') || '';
            let filename = 'export.tsv';
            // Extract filename from Content-Disposition header if available
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
            // Create a download link and trigger the download
            const blob = response.body;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            return { success: true, filename };
        }));
    }
}
DynamicViewsService.ɵfac = function DynamicViewsService_Factory(t) { return new (t || DynamicViewsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
DynamicViewsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DynamicViewsService, factory: DynamicViewsService.ɵfac });
DynamicViewsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicViewsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class FrontGalleriesService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    frontGetGallery(id_or_seo, is_legacy_url, source, page, page_size, current_product_id, sort_ascending, observe = 'body', reportProgress = false) {
        if (id_or_seo === null || id_or_seo === undefined) {
            throw new Error('Required parameter id_or_seo was null or undefined when calling frontGetGallery.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (is_legacy_url !== undefined && is_legacy_url !== null) {
            queryParameters = queryParameters.set('is_legacy_url', is_legacy_url);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (current_product_id !== undefined && current_product_id !== null) {
            queryParameters = queryParameters.set('current_product_id', current_product_id);
        }
        if (sort_ascending !== undefined && sort_ascending !== null) {
            queryParameters = queryParameters.set('sort_ascending', sort_ascending);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/galleries/${encodeURIComponent(String(id_or_seo))}`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
FrontGalleriesService.ɵfac = function FrontGalleriesService_Factory(t) { return new (t || FrontGalleriesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
FrontGalleriesService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FrontGalleriesService, factory: FrontGalleriesService.ɵfac });
FrontGalleriesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FrontGalleriesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class FrontPushNotificationsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    frontPostPushNotification(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/push_notification`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
FrontPushNotificationsService.ɵfac = function FrontPushNotificationsService_Factory(t) { return new (t || FrontPushNotificationsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
FrontPushNotificationsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FrontPushNotificationsService, factory: FrontPushNotificationsService.ɵfac });
FrontPushNotificationsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FrontPushNotificationsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class GalleryGroupsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteGalleryGroups(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/gallery_groups/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetGalleryGroup(id_or_seo, is_legacy_url, source, observe = 'body', reportProgress = false) {
        if (id_or_seo === null || id_or_seo === undefined) {
            throw new Error('Required parameter id_or_seo was null or undefined when calling cmsGetGalleryGroup.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (is_legacy_url !== undefined && is_legacy_url !== null) {
            queryParameters = queryParameters.set('is_legacy_url', is_legacy_url);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/gallery_groups/${encodeURIComponent(String(id_or_seo))}`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetGalleryGroups(page, page_size, query, query_include_headline, query_include_people, query_include_caption, query_include_keywords, from_date, to_date, contains_gallery_id, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', query);
        }
        if (query_include_headline !== undefined &&
            query_include_headline !== null) {
            queryParameters = queryParameters.set('query_include_headline', query_include_headline);
        }
        if (query_include_people !== undefined && query_include_people !== null) {
            queryParameters = queryParameters.set('query_include_people', query_include_people);
        }
        if (query_include_caption !== undefined && query_include_caption !== null) {
            queryParameters = queryParameters.set('query_include_caption', query_include_caption);
        }
        if (query_include_keywords !== undefined &&
            query_include_keywords !== null) {
            queryParameters = queryParameters.set('query_include_keywords', query_include_keywords);
        }
        if (from_date !== undefined && from_date !== null) {
            queryParameters = queryParameters.set('from_date', from_date);
        }
        if (to_date !== undefined && to_date !== null) {
            queryParameters = queryParameters.set('to_date', to_date);
        }
        if (contains_gallery_id !== undefined && contains_gallery_id !== null) {
            queryParameters = queryParameters.set('contains_gallery_id', contains_gallery_id);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/gallery_groups`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostGalleryGroup(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/gallery_groups`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetGalleryGroup(id_or_seo, is_legacy_url, source, observe = 'body', reportProgress = false) {
        if (id_or_seo === null || id_or_seo === undefined) {
            throw new Error('Required parameter id_or_seo was null or undefined when calling frontGetGalleryGroup.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (is_legacy_url !== undefined && is_legacy_url !== null) {
            queryParameters = queryParameters.set('is_legacy_url', is_legacy_url);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/gallery_groups/${encodeURIComponent(String(id_or_seo))}`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
GalleryGroupsService.ɵfac = function GalleryGroupsService_Factory(t) { return new (t || GalleryGroupsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
GalleryGroupsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: GalleryGroupsService, factory: GalleryGroupsService.ɵfac });
GalleryGroupsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GalleryGroupsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class HomepageService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    frontGetDjevojkaDana(page, page_size, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/djevojka_dana`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepage(text, page, page_size, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', text);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageAgefotostock(page, page_size, text, main_filter, provider_filter_list, refinement_filter_list, interval, interval_start, interval_end, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', text);
        }
        if (main_filter !== undefined && main_filter !== null) {
            queryParameters = queryParameters.set('main_filter', main_filter);
        }
        if (provider_filter_list) {
            queryParameters = queryParameters.set('provider_filter_list', provider_filter_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (refinement_filter_list) {
            queryParameters = queryParameters.set('refinement_filter_list', refinement_filter_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (interval !== undefined && interval !== null) {
            queryParameters = queryParameters.set('interval', interval);
        }
        if (interval_start !== undefined && interval_start !== null) {
            queryParameters = queryParameters.set('interval_start', interval_start);
        }
        if (interval_end !== undefined && interval_end !== null) {
            queryParameters = queryParameters.set('interval_end', interval_end);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/agefotostock`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageAgefotostockFilter(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/agefotostock/available_filters`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageAgencies(page, page_size, text, category_list, interval, interval_start, interval_end, tag_list, author_id, orientation, colour, agency_list, kind, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', text);
        }
        if (category_list) {
            queryParameters = queryParameters.set('category_list', category_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (interval !== undefined && interval !== null) {
            queryParameters = queryParameters.set('interval', interval);
        }
        if (interval_start !== undefined && interval_start !== null) {
            queryParameters = queryParameters.set('interval_start', interval_start);
        }
        if (interval_end !== undefined && interval_end !== null) {
            queryParameters = queryParameters.set('interval_end', interval_end);
        }
        if (tag_list) {
            queryParameters = queryParameters.set('tag_list', tag_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (orientation !== undefined && orientation !== null) {
            queryParameters = queryParameters.set('orientation', orientation);
        }
        if (colour !== undefined && colour !== null) {
            queryParameters = queryParameters.set('colour', colour);
        }
        if (agency_list) {
            queryParameters = queryParameters.set('agency_list', agency_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/agencies`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageAgenciesFilter(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/agencies/available_filters`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageAll(page, page_size, text, category_list, interval, interval_start, interval_end, tag_list, author_id, orientation, colour, kind, agency_list, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', text);
        }
        if (category_list) {
            queryParameters = queryParameters.set('category_list', category_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (interval !== undefined && interval !== null) {
            queryParameters = queryParameters.set('interval', interval);
        }
        if (interval_start !== undefined && interval_start !== null) {
            queryParameters = queryParameters.set('interval_start', interval_start);
        }
        if (interval_end !== undefined && interval_end !== null) {
            queryParameters = queryParameters.set('interval_end', interval_end);
        }
        if (tag_list) {
            queryParameters = queryParameters.set('tag_list', tag_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (orientation !== undefined && orientation !== null) {
            queryParameters = queryParameters.set('orientation', orientation);
        }
        if (colour !== undefined && colour !== null) {
            queryParameters = queryParameters.set('colour', colour);
        }
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        if (agency_list) {
            queryParameters = queryParameters.set('agency_list', agency_list.join(COLLECTION_FORMATS['pipe']));
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/all`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageAllFilter(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/all/available_filters`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageProduction(page, page_size, text, category_list, interval, interval_start, interval_end, tag_list, author_id, orientation, colour, kind, agency_list, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', text);
        }
        if (category_list) {
            queryParameters = queryParameters.set('category_list', category_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (interval !== undefined && interval !== null) {
            queryParameters = queryParameters.set('interval', interval);
        }
        if (interval_start !== undefined && interval_start !== null) {
            queryParameters = queryParameters.set('interval_start', interval_start);
        }
        if (interval_end !== undefined && interval_end !== null) {
            queryParameters = queryParameters.set('interval_end', interval_end);
        }
        if (tag_list) {
            queryParameters = queryParameters.set('tag_list', tag_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (orientation !== undefined && orientation !== null) {
            queryParameters = queryParameters.set('orientation', orientation);
        }
        if (colour !== undefined && colour !== null) {
            queryParameters = queryParameters.set('colour', colour);
        }
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        if (agency_list) {
            queryParameters = queryParameters.set('agency_list', agency_list.join(COLLECTION_FORMATS['pipe']));
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/production`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageProductionFilter(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/production/available_filters`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageReuters(page, page_size, text, category_list, interval, interval_start, interval_end, tag_list, author_id, orientation, colour, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', text);
        }
        if (category_list) {
            queryParameters = queryParameters.set('category_list', category_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (interval !== undefined && interval !== null) {
            queryParameters = queryParameters.set('interval', interval);
        }
        if (interval_start !== undefined && interval_start !== null) {
            queryParameters = queryParameters.set('interval_start', interval_start);
        }
        if (interval_end !== undefined && interval_end !== null) {
            queryParameters = queryParameters.set('interval_end', interval_end);
        }
        if (tag_list) {
            queryParameters = queryParameters.set('tag_list', tag_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (orientation !== undefined && orientation !== null) {
            queryParameters = queryParameters.set('orientation', orientation);
        }
        if (colour !== undefined && colour !== null) {
            queryParameters = queryParameters.set('colour', colour);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/reuters`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageReutersFilter(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/reuters/available_filters`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageStock(page, page_size, text, category_list, interval, interval_start, interval_end, tag_list, author_id, orientation, colour, kind, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', text);
        }
        if (category_list) {
            queryParameters = queryParameters.set('category_list', category_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (interval !== undefined && interval !== null) {
            queryParameters = queryParameters.set('interval', interval);
        }
        if (interval_start !== undefined && interval_start !== null) {
            queryParameters = queryParameters.set('interval_start', interval_start);
        }
        if (interval_end !== undefined && interval_end !== null) {
            queryParameters = queryParameters.set('interval_end', interval_end);
        }
        if (tag_list) {
            queryParameters = queryParameters.set('tag_list', tag_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (orientation !== undefined && orientation !== null) {
            queryParameters = queryParameters.set('orientation', orientation);
        }
        if (colour !== undefined && colour !== null) {
            queryParameters = queryParameters.set('colour', colour);
        }
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/stock`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageStockFilter(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/stock/available_filters`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageVideo(page, page_size, text, category_list, interval, interval_start, interval_end, tag_list, author_id, agency_list, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', text);
        }
        if (category_list) {
            queryParameters = queryParameters.set('category_list', category_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (interval !== undefined && interval !== null) {
            queryParameters = queryParameters.set('interval', interval);
        }
        if (interval_start !== undefined && interval_start !== null) {
            queryParameters = queryParameters.set('interval_start', interval_start);
        }
        if (interval_end !== undefined && interval_end !== null) {
            queryParameters = queryParameters.set('interval_end', interval_end);
        }
        if (tag_list) {
            queryParameters = queryParameters.set('tag_list', tag_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (agency_list) {
            queryParameters = queryParameters.set('agency_list', agency_list.join(COLLECTION_FORMATS['pipe']));
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/video`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageVideoFilter(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/video/available_filters`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetSearchNavigation(subportal, position_in_search, item_id, text, category_list, interval, interval_start, interval_end, tag_list, author_id, orientation, colour, kind, agency_list, observe = 'body', reportProgress = false) {
        if (subportal === null || subportal === undefined) {
            throw new Error('Required parameter subportal was null or undefined when calling frontGetSearchNavigation.');
        }
        if (position_in_search === null || position_in_search === undefined) {
            throw new Error('Required parameter position_in_search was null or undefined when calling frontGetSearchNavigation.');
        }
        if (item_id === null || item_id === undefined) {
            throw new Error('Required parameter item_id was null or undefined when calling frontGetSearchNavigation.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (subportal !== undefined && subportal !== null) {
            queryParameters = queryParameters.set('subportal', subportal);
        }
        if (position_in_search !== undefined && position_in_search !== null) {
            queryParameters = queryParameters.set('position_in_search', position_in_search);
        }
        if (item_id !== undefined && item_id !== null) {
            queryParameters = queryParameters.set('item_id', item_id);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', text);
        }
        if (category_list) {
            queryParameters = queryParameters.set('category_list', category_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (interval !== undefined && interval !== null) {
            queryParameters = queryParameters.set('interval', interval);
        }
        if (interval_start !== undefined && interval_start !== null) {
            queryParameters = queryParameters.set('interval_start', interval_start);
        }
        if (interval_end !== undefined && interval_end !== null) {
            queryParameters = queryParameters.set('interval_end', interval_end);
        }
        if (tag_list) {
            queryParameters = queryParameters.set('tag_list', tag_list.join(COLLECTION_FORMATS['pipe']));
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (orientation !== undefined && orientation !== null) {
            queryParameters = queryParameters.set('orientation', orientation);
        }
        if (colour !== undefined && colour !== null) {
            queryParameters = queryParameters.set('colour', colour);
        }
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        if (agency_list) {
            queryParameters = queryParameters.set('agency_list', agency_list.join(COLLECTION_FORMATS['pipe']));
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/home/arrow-navigation`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
HomepageService.ɵfac = function HomepageService_Factory(t) { return new (t || HomepageService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
HomepageService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HomepageService, factory: HomepageService.ɵfac });
HomepageService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HomepageService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class IPTCService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteIpct(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/iptcs/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetIpct(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/iptcs`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostIpct(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/iptcs`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
IPTCService.ɵfac = function IPTCService_Factory(t) { return new (t || IPTCService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
IPTCService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: IPTCService, factory: IPTCService.ɵfac });
IPTCService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IPTCService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class InternalUsersService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteUserGroup(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsDeleteUserGroup.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/cms/internal_users/user_groups/delete/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetInternalUser(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetInternalUser.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/internal_users/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetInternalUserList(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/internal_users`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetUserGroup(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetUserGroup.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/internal_user/user_groups/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetUserGroupList(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/internal_users/user_groups`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetUserLogingLog(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/internal_users/user_loging_log`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostInternalUser(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/internal_users`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostUserGroup(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/internal_users/user_groups`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPutInternalUser(id, body, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsPutInternalUser.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/internal_users/${encodeURIComponent(String(id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPutUserGroup(id, body, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsPutUserGroup.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/internal_user/user_groups/${encodeURIComponent(String(id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
InternalUsersService.ɵfac = function InternalUsersService_Factory(t) { return new (t || InternalUsersService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
InternalUsersService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: InternalUsersService, factory: InternalUsersService.ɵfac });
InternalUsersService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InternalUsersService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class KeywordsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteKeyword(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/keywords/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetKeyword(page, page_size, croatian_contains, english_contains, german_contains, sort_by, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (croatian_contains !== undefined && croatian_contains !== null) {
            queryParameters = queryParameters.set('croatian_contains', croatian_contains);
        }
        if (english_contains !== undefined && english_contains !== null) {
            queryParameters = queryParameters.set('english_contains', english_contains);
        }
        if (german_contains !== undefined && german_contains !== null) {
            queryParameters = queryParameters.set('german_contains', german_contains);
        }
        if (sort_by !== undefined && sort_by !== null) {
            queryParameters = queryParameters.set('sort_by', sort_by);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/keywords`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostKeyword(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/keywords`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
KeywordsService.ɵfac = function KeywordsService_Factory(t) { return new (t || KeywordsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
KeywordsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: KeywordsService, factory: KeywordsService.ɵfac });
KeywordsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(KeywordsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class LicenceTypesService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsGetLicenceTypes(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/licence_types`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostLicenceType(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/licence_types`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
LicenceTypesService.ɵfac = function LicenceTypesService_Factory(t) { return new (t || LicenceTypesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
LicenceTypesService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LicenceTypesService, factory: LicenceTypesService.ɵfac });
LicenceTypesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LicenceTypesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class PeopleService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsPostPerson(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/people`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
PeopleService.ɵfac = function PeopleService_Factory(t) { return new (t || PeopleService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
PeopleService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: PeopleService, factory: PeopleService.ɵfac });
PeopleService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PeopleService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class ProductsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteProducts(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/products/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetProductIptc(productId, observe = 'body', reportProgress = false) {
        if (productId === null || productId === undefined) {
            throw new Error('Required parameter productId was null or undefined when calling cmsGetProductIptc.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/products/${encodeURIComponent(String(productId))}/iptc`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetProducts(page, page_size, query, query_include_headline, query_include_people, query_include_caption, query_include_keywords, date_from, date_to, product_status, agency_id, author_id, original_name, content_type, by_operator_id, was_ever_downloaded, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', query);
        }
        if (query_include_headline !== undefined &&
            query_include_headline !== null) {
            queryParameters = queryParameters.set('query_include_headline', query_include_headline);
        }
        if (query_include_people !== undefined && query_include_people !== null) {
            queryParameters = queryParameters.set('query_include_people', query_include_people);
        }
        if (query_include_caption !== undefined && query_include_caption !== null) {
            queryParameters = queryParameters.set('query_include_caption', query_include_caption);
        }
        if (query_include_keywords !== undefined &&
            query_include_keywords !== null) {
            queryParameters = queryParameters.set('query_include_keywords', query_include_keywords);
        }
        if (date_from !== undefined && date_from !== null) {
            queryParameters = queryParameters.set('date_from', date_from);
        }
        if (date_to !== undefined && date_to !== null) {
            queryParameters = queryParameters.set('date_to', date_to);
        }
        if (product_status !== undefined && product_status !== null) {
            queryParameters = queryParameters.set('product_status', product_status);
        }
        if (agency_id !== undefined && agency_id !== null) {
            queryParameters = queryParameters.set('agency_id', agency_id);
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (original_name !== undefined && original_name !== null) {
            queryParameters = queryParameters.set('original_name', original_name);
        }
        if (content_type !== undefined && content_type !== null) {
            queryParameters = queryParameters.set('content_type', content_type);
        }
        if (by_operator_id !== undefined && by_operator_id !== null) {
            queryParameters = queryParameters.set('by_operator_id', by_operator_id);
        }
        if (was_ever_downloaded !== undefined && was_ever_downloaded !== null) {
            queryParameters = queryParameters.set('was_ever_downloaded', was_ever_downloaded);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/products`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsLockProducts(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/products/lock`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsReplaceProductMedia(productId, body, observe = 'body', reportProgress = false) {
        if (productId === null || productId === undefined) {
            throw new Error('Required parameter productId was null or undefined when calling cmsReplaceProductMedia.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/octet-stream'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/products/${encodeURIComponent(String(productId))}/replace`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsSaveProducts(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/products`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsUnlockProducts(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/products/unlock`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsUpdateProducts(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/products`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetProduct(id_or_seo, is_legacy_url, is_legacy_url_video, source, observe = 'body', reportProgress = false) {
        if (id_or_seo === null || id_or_seo === undefined) {
            throw new Error('Required parameter id_or_seo was null or undefined when calling frontGetProduct.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (is_legacy_url !== undefined && is_legacy_url !== null) {
            queryParameters = queryParameters.set('is_legacy_url', is_legacy_url);
        }
        if (is_legacy_url_video !== undefined && is_legacy_url_video !== null) {
            queryParameters = queryParameters.set('is_legacy_url_video', is_legacy_url_video);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/products/${encodeURIComponent(String(id_or_seo))}`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
ProductsService.ɵfac = function ProductsService_Factory(t) { return new (t || ProductsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
ProductsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ProductsService, factory: ProductsService.ɵfac });
ProductsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProductsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class ProductsFrontService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDownloadCMSProduct(id, kind, has_author_signature, source, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsDownloadCMSProduct.');
        }
        if (kind === null || kind === undefined) {
            throw new Error('Required parameter kind was null or undefined when calling cmsDownloadCMSProduct.');
        }
        if (has_author_signature === null || has_author_signature === undefined) {
            throw new Error('Required parameter has_author_signature was null or undefined when calling cmsDownloadCMSProduct.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        if (has_author_signature !== undefined && has_author_signature !== null) {
            queryParameters = queryParameters.set('has_author_signature', has_author_signature);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['image/jpeg'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/cms/products/${encodeURIComponent(String(id))}/download/cms`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontCalculateProductPrice(id, source, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling frontCalculateProductPrice.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/products/${encodeURIComponent(String(id))}/calculate`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontDownloadFullCreateLink(id, kind, has_author_signature, source, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling frontDownloadFullCreateLink.');
        }
        if (kind === null || kind === undefined) {
            throw new Error('Required parameter kind was null or undefined when calling frontDownloadFullCreateLink.');
        }
        if (has_author_signature === null || has_author_signature === undefined) {
            throw new Error('Required parameter has_author_signature was null or undefined when calling frontDownloadFullCreateLink.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        if (has_author_signature !== undefined && has_author_signature !== null) {
            queryParameters = queryParameters.set('has_author_signature', has_author_signature);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/products/${encodeURIComponent(String(id))}/download/full/link`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontEmbedCreateScript(id, kind, has_author_signature, source, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling frontDownloadFullCreateLink.');
        }
        if (kind === null || kind === undefined) {
            throw new Error('Required parameter kind was null or undefined when calling frontDownloadFullCreateLink.');
        }
        if (has_author_signature === null || has_author_signature === undefined) {
            throw new Error('Required parameter has_author_signature was null or undefined when calling frontDownloadFullCreateLink.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        if (has_author_signature !== undefined && has_author_signature !== null) {
            queryParameters = queryParameters.set('has_author_signature', has_author_signature);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/products/${encodeURIComponent(String(id))}/download/full/embed`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontDownloadFullProduct(id, kind, has_author_signature, source, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling frontDownloadFullProduct.');
        }
        if (kind === null || kind === undefined) {
            throw new Error('Required parameter kind was null or undefined when calling frontDownloadFullProduct.');
        }
        if (has_author_signature === null || has_author_signature === undefined) {
            throw new Error('Required parameter has_author_signature was null or undefined when calling frontDownloadFullProduct.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        if (has_author_signature !== undefined && has_author_signature !== null) {
            queryParameters = queryParameters.set('has_author_signature', has_author_signature);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['image/jpeg'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/products/${encodeURIComponent(String(id))}/download/full`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontDownloadProductPreview(id, source, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling frontDownloadProductPreview.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['image/jpeg'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/products/${encodeURIComponent(String(id))}/download/preview`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
            responseType: 'blob',
        });
    }
    frontDownloadWithToken(tokenId, observe = 'body', reportProgress = false) {
        if (tokenId === null || tokenId === undefined) {
            throw new Error('Required parameter tokenId was null or undefined when calling frontDownloadWithToken.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['image/jpeg'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/products/download/token/${encodeURIComponent(String(tokenId))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontRunProductAction(id, action, kind, has_author_signature, source, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling frontRunProductAction.');
        }
        if (action === null || action === undefined) {
            throw new Error('Required parameter action was null or undefined when calling frontRunProductAction.');
        }
        if (kind === null || kind === undefined) {
            throw new Error('Required parameter kind was null or undefined when calling frontRunProductAction.');
        }
        if (has_author_signature === null || has_author_signature === undefined) {
            throw new Error('Required parameter has_author_signature was null or undefined when calling frontRunProductAction.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        if (has_author_signature !== undefined && has_author_signature !== null) {
            queryParameters = queryParameters.set('has_author_signature', has_author_signature);
        }
        if (source !== undefined && source !== null) {
            queryParameters = queryParameters.set('source', source);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/products/${encodeURIComponent(String(id))}/actions/${encodeURIComponent(String(action))}`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
ProductsFrontService.ɵfac = function ProductsFrontService_Factory(t) { return new (t || ProductsFrontService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
ProductsFrontService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ProductsFrontService, factory: ProductsFrontService.ɵfac });
ProductsFrontService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProductsFrontService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class ProfileService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsCreateProfileSubuser(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/profile/subusers`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsDeleteProfileSubuser(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/profile/subusers/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsDeleteProfileSubuserProfileImage(userId, observe = 'body', reportProgress = false) {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling cmsDeleteProfileSubuserProfileImage.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('delete', `${this.basePath}/profile/users/${encodeURIComponent(String(userId))}/profile_image`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsUpdateProfileSubuser(userId, body, observe = 'body', reportProgress = false) {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling cmsUpdateProfileSubuser.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/profile/users/${encodeURIComponent(String(userId))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsUpdateProfileSubuserProfileImage(userId, body, observe = 'body', reportProgress = false) {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling cmsUpdateProfileSubuserProfileImage.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['image/jpg'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/profile/users/${encodeURIComponent(String(userId))}/profile_image`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontDeleteProfileImage(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('delete', `${this.basePath}/current_user/profile_image`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetCurrentUser(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/current_user`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetNewsletterStatus(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/newsletter_status`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetProfileContractPDF(contractId, observe = 'body', reportProgress = false) {
        if (contractId === null || contractId === undefined) {
            throw new Error('Required parameter contractId was null or undefined when calling frontGetProfileContractPDF.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/pdf'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/profile/contracts/${encodeURIComponent(String(contractId))}/pdf`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetProfileContracts(page, page_size, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/profile/contracts`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetProfileDownloads(page, page_size, date_from, date_to, content_type, user_type, user_id, author_id, agency_id, variation, above_price, below_price, product_name, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        if (date_from !== undefined && date_from !== null) {
            queryParameters = queryParameters.set('date_from', date_from);
        }
        if (date_to !== undefined && date_to !== null) {
            queryParameters = queryParameters.set('date_to', date_to);
        }
        if (content_type !== undefined && content_type !== null) {
            queryParameters = queryParameters.set('content_type', content_type);
        }
        if (user_type !== undefined && user_type !== null) {
            queryParameters = queryParameters.set('user_type', user_type);
        }
        if (user_id !== undefined && user_id !== null) {
            queryParameters = queryParameters.set('user_id', user_id);
        }
        if (author_id !== undefined && author_id !== null) {
            queryParameters = queryParameters.set('author_id', author_id);
        }
        if (agency_id !== undefined && agency_id !== null) {
            queryParameters = queryParameters.set('agency_id', agency_id);
        }
        if (variation !== undefined && variation !== null) {
            queryParameters = queryParameters.set('variation', variation);
        }
        if (above_price !== undefined && above_price !== null) {
            queryParameters = queryParameters.set('above_price', above_price);
        }
        if (below_price !== undefined && below_price !== null) {
            queryParameters = queryParameters.set('below_price', below_price);
        }
        if (product_name !== undefined && product_name !== null) {
            queryParameters = queryParameters.set('product_name', product_name);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/profile/downloads`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetProfileInvoicePDF(invoiceId, observe = 'body', reportProgress = false) {
        if (invoiceId === null || invoiceId === undefined) {
            throw new Error('Required parameter invoiceId was null or undefined when calling frontGetProfileInvoicePDF.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/pdf'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/profile/invoices/${encodeURIComponent(String(invoiceId))}/pdf`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
            responseType: 'blob',
        });
    }
    frontGetProfileInvoices(page, page_size, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/profile/invoices`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetProfileSubusers(page, page_size, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (page_size !== undefined && page_size !== null) {
            queryParameters = queryParameters.set('page_size', page_size);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/profile/subusers`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontSendContactUsRequest(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/contact_us`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontSendProfileContactRequest(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/profile/contact`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontUpdateCurrentUser(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/current_user`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontUpdateNewsletterStatus(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/newsletter_status`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontUpdateProfileImage(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['image/jpg'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/current_user/profile_image`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
ProfileService.ɵfac = function ProfileService_Factory(t) { return new (t || ProfileService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
ProfileService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ProfileService, factory: ProfileService.ɵfac });
ProfileService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProfileService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class ProperNameService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteProperName(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/proper_names/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetProperName(first_name_contains, last_name_contains, date_of_birth, date_of_death, sort_by, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (first_name_contains !== undefined && first_name_contains !== null) {
            queryParameters = queryParameters.set('first_name_contains', first_name_contains);
        }
        if (last_name_contains !== undefined && last_name_contains !== null) {
            queryParameters = queryParameters.set('last_name_contains', last_name_contains);
        }
        if (date_of_birth !== undefined && date_of_birth !== null) {
            queryParameters = queryParameters.set('date_of_birth', date_of_birth);
        }
        if (date_of_death !== undefined && date_of_death !== null) {
            queryParameters = queryParameters.set('date_of_death', date_of_death);
        }
        if (sort_by !== undefined && sort_by !== null) {
            queryParameters = queryParameters.set('sort_by', sort_by);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/proper_names`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostProperName(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/proper_names`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
ProperNameService.ɵfac = function ProperNameService_Factory(t) { return new (t || ProperNameService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
ProperNameService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ProperNameService, factory: ProperNameService.ɵfac });
ProperNameService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProperNameService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class RegistrationLoginService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    frontApproveLogin(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/approve_login`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontChangePassword(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/change_password`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontConfirmEmail(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/confirm_email`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontForgotPassword(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/forgot_password`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetRegistrationConsets(kind, observe = 'body', reportProgress = false) {
        if (kind === null || kind === undefined) {
            throw new Error('Required parameter kind was null or undefined when calling frontGetRegistrationConsets.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (kind !== undefined && kind !== null) {
            queryParameters = queryParameters.set('kind', kind);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/registration_consents`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontLoginUser(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/login`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontRegisterUser(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/registration`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
RegistrationLoginService.ɵfac = function RegistrationLoginService_Factory(t) { return new (t || RegistrationLoginService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
RegistrationLoginService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: RegistrationLoginService, factory: RegistrationLoginService.ɵfac });
RegistrationLoginService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RegistrationLoginService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class SettingsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    getSettings(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/settings`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
SettingsService.ɵfac = function SettingsService_Factory(t) { return new (t || SettingsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
SettingsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SettingsService, factory: SettingsService.ɵfac });
SettingsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SettingsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class SpecialInstructionsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsGetSpecialInstructions(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/special_instructions`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostSpecialInstructions(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/special_instructions`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
SpecialInstructionsService.ɵfac = function SpecialInstructionsService_Factory(t) { return new (t || SpecialInstructionsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
SpecialInstructionsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SpecialInstructionsService, factory: SpecialInstructionsService.ɵfac });
SpecialInstructionsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpecialInstructionsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class SpecialOfferTypesService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsPostSpecialOfferType(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/special_offer_types`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
SpecialOfferTypesService.ɵfac = function SpecialOfferTypesService_Factory(t) { return new (t || SpecialOfferTypesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
SpecialOfferTypesService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SpecialOfferTypesService, factory: SpecialOfferTypesService.ɵfac });
SpecialOfferTypesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpecialOfferTypesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class TagsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteTags(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/tags/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetTag(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/tags`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostTag(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/tags`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
TagsService.ɵfac = function TagsService_Factory(t) { return new (t || TagsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
TagsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TagsService, factory: TagsService.ɵfac });
TagsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TagsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class UploadSessionsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsAppendFileToGallery(galleryId, body, observe = 'body', reportProgress = false) {
        if (galleryId === null || galleryId === undefined) {
            throw new Error('Required parameter galleryId was null or undefined when calling cmsAppendFileToGallery.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/octet-stream'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/upload_sessions/gallery/${encodeURIComponent(String(galleryId))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsDeleteMediaItems(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/upload_sessions/delete`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsDeleteUploadSession(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('delete', `${this.basePath}/cms/upload_sessions`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetUploadSession(diff_after, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (diff_after !== undefined && diff_after !== null) {
            queryParameters = queryParameters.set('diff_after', diff_after.toISOString());
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/upload_sessions`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPublishUploadSession(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/upload_sessions/publish`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPutUploadSession(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/upload_sessions`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsReplaceMediaMedia(mediaId, body, observe = 'body', reportProgress = false) {
        if (mediaId === null || mediaId === undefined) {
            throw new Error('Required parameter mediaId was null or undefined when calling cmsReplaceMediaMedia.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/octet-stream'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/upload_sessions/${encodeURIComponent(String(mediaId))}/replace`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsUploadUploadSessionFile(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/octet-stream'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/upload_sessions/upload`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
UploadSessionsService.ɵfac = function UploadSessionsService_Factory(t) { return new (t || UploadSessionsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
UploadSessionsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: UploadSessionsService, factory: UploadSessionsService.ɵfac });
UploadSessionsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadSessionsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class UserRightsService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsGetUserRights(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/user_rights`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostUserRights(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/user_rights`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
UserRightsService.ɵfac = function UserRightsService_Factory(t) { return new (t || UserRightsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
UserRightsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: UserRightsService, factory: UserRightsService.ɵfac });
UserRightsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserRightsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class WebAdministrationService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    cmsDeleteTemplate(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsDeleteTemplate.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/cms/web_administration/homepage/${encodeURIComponent(String(id))}/delete`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsDuplicateTemplate(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsDuplicateTemplate.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/cms/web_administration/homepage/${encodeURIComponent(String(id))}/duplicate`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetHomepageTemplate(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsGetHomepageTemplate.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/web_administration/homepage/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetHomepageTemplateList(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/web_administration/homepage`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsGetPublishedTemplate(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/cms/web_administration/homepage/published`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPostHomepageTemplate(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/web_administration/homepage`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPublishTemplate(id, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsPublishTemplate.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/cms/web_administration/homepage/${encodeURIComponent(String(id))}/publish`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsPutHomepageTemplate(id, body, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsPutHomepageTemplate.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/cms/web_administration/homepage/${encodeURIComponent(String(id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsRenameTemplate(id, body, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cmsRenameTemplate.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/web_administration/homepage/${encodeURIComponent(String(id))}/rename`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    cmsUploadHomePageMedia(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/octet-stream'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/cms/web_administration/homepage/upload`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetHomepageTemplateList(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/web_administration/homepage`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    frontGetPublishedTemplate(observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/web_administration/homepage/published`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
WebAdministrationService.ɵfac = function WebAdministrationService_Factory(t) { return new (t || WebAdministrationService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
WebAdministrationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: WebAdministrationService, factory: WebAdministrationService.ɵfac });
WebAdministrationService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WebAdministrationService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

const APIS = [
    AgenciesService,
    AuthorsService,
    AutocompleteService,
    CMSService,
    CMSCompaniesService,
    CMSContractsService,
    CMSGalleriesService,
    CMSUsersService,
    CartService,
    CategoriesService,
    DynamicViewsService,
    FrontGalleriesService,
    FrontPushNotificationsService,
    GalleryGroupsService,
    HomepageService,
    IPTCService,
    InternalUsersService,
    KeywordsService,
    LicenceTypesService,
    PeopleService,
    ProductsService,
    ProductsFrontService,
    ProfileService,
    ProperNameService,
    RegistrationLoginService,
    SettingsService,
    SpecialInstructionsService,
    SpecialOfferTypesService,
    TagsService,
    UploadSessionsService,
    UserRightsService,
    WebAdministrationService,
];

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var AddToCart;
(function (AddToCart) {
    AddToCart.VariationEnum = {
        PRINT: 'PRINT',
        WEB: 'WEB',
    };
    AddToCart.SourceEnum = {
        PIXSELL: 'PIXSELL',
        THPPHOTOSERVICE: 'THP_PHOTO_SERVICE',
    };
})(AddToCart || (AddToCart = {}));

var Agency;
(function (Agency) {
    Agency.ContentTypeEnum = {
        PICTURE: 'PICTURE,',
        VIDEO: 'VIDEO,',
        PICTUREVIDEO: 'PICTURE_VIDEO,',
        ILLUSTRATION: 'ILLUSTRATION,',
        PICTUREVIDEO_4: 'PICTURE_VIDEO,',
        PICTURE_5: 'PICTURE,',
        VIDEO_6: 'VIDEO,',
        ALL: 'ALL',
    };
})(Agency || (Agency = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var AgencyIpctTag;
(function (AgencyIpctTag) {
    AgencyIpctTag.ValueEnum = {
        REPLACE: 'REPLACE',
        APPEND: 'APPEND',
        PREPEND: 'PREPEND',
    };
})(AgencyIpctTag || (AgencyIpctTag = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var BlockTypeBlock;
(function (BlockTypeBlock) {
    BlockTypeBlock.IdEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
    };
    BlockTypeBlock.VariationEnum = {
        Block: 'block',
    };
})(BlockTypeBlock || (BlockTypeBlock = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var BlockTypeSection;
(function (BlockTypeSection) {
    BlockTypeSection.IdEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
    };
    BlockTypeSection.VariationEnum = {
        Section: 'section',
    };
})(BlockTypeSection || (BlockTypeSection = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var Cart;
(function (Cart) {
    Cart.CurrencyEnum = {
        HRK: 'HRK',
        EUR: 'EUR',
    };
    Cart.AvailablePaymentMethodsEnum = {
        CARD: 'CARD',
        KEKSPAY: 'KEKS_PAY',
        PAYPAL: 'PAYPAL',
        DOWNLOAD: 'DOWNLOAD',
    };
})(Cart || (Cart = {}));

var CartLine;
(function (CartLine) {
    CartLine.CurrencyEnum = {
        HRK: 'HRK',
        EUR: 'EUR',
    };
    CartLine.VariationEnum = {
        PRINT: 'PRINT',
        WEB: 'WEB',
    };
    CartLine.KindEnum = {
        SINGLEPRODUCT: 'SINGLE_PRODUCT',
        GALLERY: 'GALLERY',
        GALLERYGROUP: 'GALLERY_GROUP',
    };
    CartLine.SourceEnum = {
        PIXSELL: 'PIXSELL',
        THPPHOTOSERVICE: 'THP_PHOTO_SERVICE',
    };
})(CartLine || (CartLine = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var CartPaymentGatewayRequest;
(function (CartPaymentGatewayRequest) {
    CartPaymentGatewayRequest.CurrencyEnum = {
        HRK: 'HRK',
        EUR: 'EUR',
    };
    CartPaymentGatewayRequest.LangEnum = {
        EN: 'EN',
        HR: 'HR',
    };
})(CartPaymentGatewayRequest || (CartPaymentGatewayRequest = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var CartPaymentGatewayResponse;
(function (CartPaymentGatewayResponse) {
    CartPaymentGatewayResponse.PaymentMethodEnum = {
        CARD: 'CARD',
        KEKSPAY: 'KEKS_PAY',
        PAYPAL: 'PAYPAL',
        DOWNLOAD: 'DOWNLOAD',
    };
    CartPaymentGatewayResponse.StatusEnum = {
        SUCCESS: 'SUCCESS',
        ERROR: 'ERROR',
        CANCEL: 'CANCEL',
        FAILURE: 'FAILURE',
    };
    CartPaymentGatewayResponse.PartnerEnum = {
        CARD: 'CARD',
        PAYPAL: 'PAYPAL',
        KEKSPAY: 'KEKS_PAY',
        AIRCASH: 'AIRCASH',
    };
})(CartPaymentGatewayResponse || (CartPaymentGatewayResponse = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var CartPaymentRequest;
(function (CartPaymentRequest) {
    CartPaymentRequest.PaymentMethodEnum = {
        CARD: 'CARD',
        KEKSPAY: 'KEKS_PAY',
        PAYPAL: 'PAYPAL',
        DOWNLOAD: 'DOWNLOAD',
    };
})(CartPaymentRequest || (CartPaymentRequest = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var CmsEditingCompany;
(function (CmsEditingCompany) {
    CmsEditingCompany.DownloadTypePermissionsEnum = {
        PHOTO: 'PHOTO',
        PHOTOLARGE: 'PHOTO_LARGE',
        PHOTOLARGESIGNATURE: 'PHOTO_LARGE_SIGNATURE',
        PHOTOSMALL: 'PHOTO_SMALL',
        PHOTOSMALLSIGNATURE: 'PHOTO_SMALL_SIGNATURE',
        VIDEO: 'VIDEO',
    };
    CmsEditingCompany.LangEnum = {
        EN: 'EN',
        HR: 'HR',
    };
})(CmsEditingCompany || (CmsEditingCompany = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var CmsEditingUser;
(function (CmsEditingUser) {
    CmsEditingUser.StateEnum = {
        UNCONFIRMEDIDENTITY: 'UNCONFIRMED_IDENTITY',
        PENDINGAPPROVAL: 'PENDING_APPROVAL',
        APPROVED: 'APPROVED',
        DELETED: 'DELETED',
    };
    CmsEditingUser.KindEnum = {
        SMALL: 'SMALL',
        CORPORATE: 'CORPORATE',
    };
    CmsEditingUser.CompanyRoleEnum = {
        OWNER: 'OWNER',
        ADMIN: 'ADMIN',
        USER: 'USER',
    };
    CmsEditingUser.DownloadTypePermissionsEnum = {
        PHOTO: 'PHOTO',
        PHOTOLARGE: 'PHOTO_LARGE',
        PHOTOLARGESIGNATURE: 'PHOTO_LARGE_SIGNATURE',
        PHOTOSMALL: 'PHOTO_SMALL',
        PHOTOSMALLSIGNATURE: 'PHOTO_SMALL_SIGNATURE',
        VIDEO: 'VIDEO',
    };
    CmsEditingUser.UserPermissionsEnum = {
        FAFPREAD: 'F_AFP_READ',
        FAGENCIESREAD: 'F_AGENCIES_READ',
        FREUTERSREAD: 'F_REUTERS_READ',
        FSTOCKREAD: 'F_STOCK_READ',
        FGIRLOFDAYREAD: 'F_GIRL_OF_DAY_READ',
        SUPERADMIN: 'SUPERADMIN',
        DEVELOPER: 'DEVELOPER',
        IMPORTREAD: 'IMPORT_READ',
        IMPORTEDIT: 'IMPORT_EDIT',
        IMPORTCREATE: 'IMPORT_CREATE',
        IMPORTDELETE: 'IMPORT_DELETE',
        CPRODUCTSREAD: 'C_PRODUCTS_READ',
        CPRODUCTSEDIT: 'C_PRODUCTS_EDIT',
        CPRODUCTSCREATE: 'C_PRODUCTS_CREATE',
        CPRODUCTSDELETE: 'C_PRODUCTS_DELETE',
        CGALLERIESREAD: 'C_GALLERIES_READ',
        CGALLERIESEDIT: 'C_GALLERIES_EDIT',
        CGALLERIESCREATE: 'C_GALLERIES_CREATE',
        CGALLERIESDELETE: 'C_GALLERIES_DELETE',
        CGALLERIESPUBLISH: 'C_GALLERIES_PUBLISH',
        CGALLERYGROUPSREAD: 'C_GALLERY_GROUPS_READ',
        CGALLERYGROUPSEDIT: 'C_GALLERY_GROUPS_EDIT',
        CGALLERYGROUPSCREATE: 'C_GALLERY_GROUPS_CREATE',
        CGALLERYGROUPSDELETE: 'C_GALLERY_GROUPS_DELETE',
        CGALLERYGROUPSPUBLISH: 'C_GALLERY_GROUPS_PUBLISH',
        CARTICLESREAD: 'C_ARTICLES_READ',
        CARTICLESEDIT: 'C_ARTICLES_EDIT',
        CARTICLESCREATE: 'C_ARTICLES_CREATE',
        CARTICLESDELETE: 'C_ARTICLES_DELETE',
        CARTICLESPUBLISH: 'C_ARTICLES_PUBLISH',
        CCATEGORIESREAD: 'C_CATEGORIES_READ',
        CCATEGORIESEDIT: 'C_CATEGORIES_EDIT',
        CCATEGORIESCREATE: 'C_CATEGORIES_CREATE',
        CCATEGORIESDELETE: 'C_CATEGORIES_DELETE',
        CCATEGORIESPUBLISH: 'C_CATEGORIES_PUBLISH',
        NEWSLETTERREAD: 'NEWSLETTER_READ',
        NEWSLETTEREDIT: 'NEWSLETTER_EDIT',
        NEWSLETTERCREATE: 'NEWSLETTER_CREATE',
        NEWSLETTERDELETE: 'NEWSLETTER_DELETE',
        UCCOMPANIESREAD: 'UC_COMPANIES_READ',
        UCCOMPANIESEDIT: 'UC_COMPANIES_EDIT',
        UCCOMPANIESCREATE: 'UC_COMPANIES_CREATE',
        UCCOMPANIESDELETE: 'UC_COMPANIES_DELETE',
        UCUSERSREAD: 'UC_USERS_READ',
        UCUSERSEDIT: 'UC_USERS_EDIT',
        UCUSERSCREATE: 'UC_USERS_CREATE',
        UCUSERSDELETE: 'UC_USERS_DELETE',
        UCDOWNLOADSREAD: 'UC_DOWNLOADS_READ',
        UCDOWNLOADSEDIT: 'UC_DOWNLOADS_EDIT',
        UCDOWNLOADSCREATE: 'UC_DOWNLOADS_CREATE',
        UCDOWNLOADSDELETE: 'UC_DOWNLOADS_DELETE',
        UCCONTRACTSREAD: 'UC_CONTRACTS_READ',
        UCCONTRACTSEDIT: 'UC_CONTRACTS_EDIT',
        UCCONTRACTSCREATE: 'UC_CONTRACTS_CREATE',
        UCCONTRACTSDELETE: 'UC_CONTRACTS_DELETE',
        UCINVOICESREAD: 'UC_INVOICES_READ',
        UCINVOICESEDIT: 'UC_INVOICES_EDIT',
        UCINVOICESCREATE: 'UC_INVOICES_CREATE',
        UCINVOICESDELETE: 'UC_INVOICES_DELETE',
        DAAGENCIESREAD: 'DA_AGENCIES_READ',
        DAAGENCIESEDIT: 'DA_AGENCIES_EDIT',
        DAAGENCIESCREATE: 'DA_AGENCIES_CREATE',
        DAAGENCIESDELETE: 'DA_AGENCIES_DELETE',
        DAIPTCREAD: 'DA_IPTC_READ',
        DAIPTCEDIT: 'DA_IPTC_EDIT',
        DAIPTCCREATE: 'DA_IPTC_CREATE',
        DAIPTCDELETE: 'DA_IPTC_DELETE',
        DAKEYWORDSREAD: 'DA_KEYWORDS_READ',
        DAKEYWORDSEDIT: 'DA_KEYWORDS_EDIT',
        DAKEYWORDSCREATE: 'DA_KEYWORDS_CREATE',
        DAKEYWORDSDELETE: 'DA_KEYWORDS_DELETE',
        DAPROPERNAMESREAD: 'DA_PROPER_NAMES_READ',
        DAPROPERNAMESEDIT: 'DA_PROPER_NAMES_EDIT',
        DAPROPERNAMESCREATE: 'DA_PROPER_NAMES_CREATE',
        DAPROPERNAMESDELETE: 'DA_PROPER_NAMES_DELETE',
        DATAGSREAD: 'DA_TAGS_READ',
        DATAGSEDIT: 'DA_TAGS_EDIT',
        DATAGSCREATE: 'DA_TAGS_CREATE',
        DATAGSDELETE: 'DA_TAGS_DELETE',
        DAPHOTOREPORTERSREAD: 'DA_PHOTOREPORTERS_READ',
        DAPHOTOREPORTERSEDIT: 'DA_PHOTOREPORTERS_EDIT',
        DAPHOTOREPORTERSCREATE: 'DA_PHOTOREPORTERS_CREATE',
        DAPHOTOREPORTERSDELETE: 'DA_PHOTOREPORTERS_DELETE',
        WAHOMEREAD: 'WA_HOME_READ',
        WAHOMEEDIT: 'WA_HOME_EDIT',
        WAHOMECREATE: 'WA_HOME_CREATE',
        WAHOMEDELETE: 'WA_HOME_DELETE',
        WAHOMEPUBLISH: 'WA_HOME_PUBLISH',
        WAABOUTUSREAD: 'WA_ABOUT_US_READ',
        WAABOUTUSEDIT: 'WA_ABOUT_US_EDIT',
        WAABOUTUSCREATE: 'WA_ABOUT_US_CREATE',
        WAABOUTUSDELETE: 'WA_ABOUT_US_DELETE',
        WAABOUTUSPUBLISH: 'WA_ABOUT_US_PUBLISH',
        WACONTENTPAGESREAD: 'WA_CONTENT_PAGES_READ',
        WACONTENTPAGESEDIT: 'WA_CONTENT_PAGES_EDIT',
        WACONTENTPAGESCREATE: 'WA_CONTENT_PAGES_CREATE',
        WACONTENTPAGESDELETE: 'WA_CONTENT_PAGES_DELETE',
        WACONTENTPAGESPUBLISH: 'WA_CONTENT_PAGES_PUBLISH',
        WASTATICPAGESREAD: 'WA_STATIC_PAGES_READ',
        WASTATICPAGESEDIT: 'WA_STATIC_PAGES_EDIT',
        WASTATICPAGESCREATE: 'WA_STATIC_PAGES_CREATE',
        WASTATICPAGESDELETE: 'WA_STATIC_PAGES_DELETE',
        WASTATICPAGESPUBLISH: 'WA_STATIC_PAGES_PUBLISH',
        FINPRODUCTDOWNLOADSREAD: 'FIN_PRODUCT_DOWNLOADS_READ',
        FINPRODUCTDOWNLOADSEDIT: 'FIN_PRODUCT_DOWNLOADS_EDIT',
        FINPRODUCTDOWNLOADSCREATE: 'FIN_PRODUCT_DOWNLOADS_CREATE',
        FINPRODUCTDOWNLOADSDELETE: 'FIN_PRODUCT_DOWNLOADS_DELETE',
        FINADMINISTRATIONREAD: 'FIN_ADMINISTRATION_READ',
        FINADMINISTRATIONEDIT: 'FIN_ADMINISTRATION_EDIT',
        FINADMINISTRATIONCREATE: 'FIN_ADMINISTRATION_CREATE',
        FINADMINISTRATIONDELETE: 'FIN_ADMINISTRATION_DELETE',
        FINDISCOUNTREAD: 'FIN_DISCOUNT_READ',
        FINDISCOUNTEDIT: 'FIN_DISCOUNT_EDIT',
        FINDISCOUNTCREATE: 'FIN_DISCOUNT_CREATE',
        FINDISCOUNTDELETE: 'FIN_DISCOUNT_DELETE',
        FININVOICESREAD: 'FIN_INVOICES_READ',
        FININVOICESEDIT: 'FIN_INVOICES_EDIT',
        FININVOICESCREATE: 'FIN_INVOICES_CREATE',
        FININVOICESDELETE: 'FIN_INVOICES_DELETE',
        STATISTICSREAD: 'STATISTICS_READ',
        STATISTICSEDIT: 'STATISTICS_EDIT',
        STATISTICSCREATE: 'STATISTICS_CREATE',
        STATISTICSDELETE: 'STATISTICS_DELETE',
        IUINTERNALUSERSREAD: 'IU_INTERNAL_USERS_READ',
        IUINTERNALUSERSEDIT: 'IU_INTERNAL_USERS_EDIT',
        IUINTERNALUSERSCREATE: 'IU_INTERNAL_USERS_CREATE',
        IUINTERNALUSERSDELETE: 'IU_INTERNAL_USERS_DELETE',
        IUUSERGROUPSREAD: 'IU_USER_GROUPS_READ',
        IUUSERGROUPSEDIT: 'IU_USER_GROUPS_EDIT',
        IUUSERGROUPSCREATE: 'IU_USER_GROUPS_CREATE',
        IUUSERGROUPSDELETE: 'IU_USER_GROUPS_DELETE',
        IUUSERLOGINLOGREAD: 'IU_USER_LOGIN_LOG_READ',
        IUUSERLOGINLOGEDIT: 'IU_USER_LOGIN_LOG_EDIT',
        IUUSERLOGINLOGCREATE: 'IU_USER_LOGIN_LOG_CREATE',
        IUUSERLOGINLOGDELETE: 'IU_USER_LOGIN_LOG_DELETE',
        ACTIVITYLOGREAD: 'ACTIVITY_LOG_READ',
        ACTIVITYLOGEDIT: 'ACTIVITY_LOG_EDIT',
        ACTIVITYLOGCREATE: 'ACTIVITY_LOG_CREATE',
        ACTIVITYLOGDELETE: 'ACTIVITY_LOG_DELETE',
        CONTACTFORMREAD: 'CONTACT_FORM_READ',
        CONTACTFORMEDIT: 'CONTACT_FORM_EDIT',
        CONTACTFORMCREATE: 'CONTACT_FORM_CREATE',
        CONTACTFORMDELETE: 'CONTACT_FORM_DELETE',
    };
})(CmsEditingUser || (CmsEditingUser = {}));

var Company;
(function (Company) {
    Company.StatusEnum = {
        PENDING: 'PENDING',
        ACTIVATED: 'ACTIVATED',
    };
    Company.DownloadTypePremissionsEnum = {
        PHOTO: 'PHOTO',
        PHOTOLARGE: 'PHOTO_LARGE',
        PHOTOLARGESIGNATURE: 'PHOTO_LARGE_SIGNATURE',
        PHOTOSMALL: 'PHOTO_SMALL',
        PHOTOSMALLSIGNATURE: 'PHOTO_SMALL_SIGNATURE',
        VIDEO: 'VIDEO',
    };
})(Company || (Company = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var Contract;
(function (Contract) {
    Contract.StatusEnum = {
        ACTIVE: 'ACTIVE',
        INACTIVE: 'INACTIVE',
    };
})(Contract || (Contract = {}));

var ContractLine;
(function (ContractLine) {
    ContractLine.LineTypeEnum = {
        FLATRATE: 'FLAT_RATE',
        PERCENTAGE: 'PERCENTAGE',
    };
    ContractLine.InvoiceProductEnum = {
        PDAgFD: 'PD_AgF_D',
        PDAgVD: 'PD_AgV_D',
        PDPxFD: 'PD_PxF_D',
        PDPxFK: 'PD_PxF_K',
        PDPxFSA: 'PD_PxF_S_A',
        PDPxFSD: 'PD_PxF_S_D',
        PDPxVD: 'PD_PxV_D',
        PojedinacniDownload: 'PojedinacniDownload',
        Predujam: 'Predujam',
        RPAgFD: 'RP_AgF_D',
        RPAgVD: 'RP_AgV_D',
        RPPxFD: 'RP_PxF_D',
        RPPxVD: 'RP_PxV_D',
        UgMNAgFD: 'UgMN_AgF_D',
        UgMNAgVD: 'UgMN_AgV_D',
        UgMNPxFD: 'UgMN_PxF_D',
        UgMNPxVD: 'UgMN_PxV_D',
        UgRaAgFD: 'UgRa_AgF_D',
        UgRaAgVD: 'UgRa_AgV_D',
        UgRaPxFD: 'UgRa_PxF_D',
        UgRaPxVD: 'UgRa_PxV_D',
    };
    ContractLine.ContentTypeEnum = {
        PHOTO: 'PHOTO',
        VIDEO: 'VIDEO',
        PHOTOVIDEO: 'PHOTO_VIDEO',
    };
})(ContractLine || (ContractLine = {}));

var Download;
(function (Download) {
    Download.ContentTypeEnum = {
        PHOTO: 'PHOTO',
        VIDEO: 'VIDEO',
    };
    Download.CurrencyEnum = {
        HRK: 'HRK',
        EUR: 'EUR',
    };
    Download.VariationEnum = {
        PRINT: 'PRINT',
        WEB: 'WEB',
    };
    Download.EuroModeEnum = {
        HRKONLY: 'HRK_ONLY',
        BIGHRKSMALLEUR: 'BIG_HRK_SMALL_EUR',
        BIGEURSMALLHRK: 'BIG_EUR_SMALL_HRK',
        EURONLY: 'EUR_ONLY',
    };
})(Download || (Download = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var DynamicView;
(function (DynamicView) {
    DynamicView.KindEnum = {
        INDEX: 'INDEX',
        VIEWEDIT: 'VIEW_EDIT',
        CREATE: 'CREATE',
    };
    DynamicView.AllowedActionsEnum = {
        CREATE: 'CREATE',
        READ: 'READ',
        UPDATE: 'UPDATE',
        DELETE: 'DELETE',
        INDEX: 'INDEX',
    };
})(DynamicView || (DynamicView = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var DynamicViewField;
(function (DynamicViewField) {
    DynamicViewField.KindEnum = {
        STRING: 'STRING',
        INTEGER: 'INTEGER',
        DECIMAL: 'DECIMAL',
        BOOLEAN: 'BOOLEAN',
        TEXT: 'TEXT',
        DROPDOWN: 'DROPDOWN',
        TAGS: 'TAGS',
        DATETIME: 'DATETIME',
        INLINE_TABLE: 'INLINE_TABLE'
    };
})(DynamicViewField || (DynamicViewField = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var DynamicViewValidation;
(function (DynamicViewValidation) {
    DynamicViewValidation.KindEnum = {
        EMAIL: 'EMAIL',
        MINLENGTH: 'MIN_LENGTH',
        MAXLENGTH: 'MAX_LENGTH',
    };
})(DynamicViewValidation || (DynamicViewValidation = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var FinanceInvoice;
(function (FinanceInvoice) {
    FinanceInvoice.TypeEnum = {
        Invoice: 'invoice',
        ProFormaInvoice: 'pro_forma_invoice',
        Storno: 'storno',
        StornoPredujma: 'storno_predujma',
        Odobrenje: 'odobrenje',
        Tereenje: 'terećenje',
    };
    FinanceInvoice.PaymentMethodEnum = {
        CARD: 'CARD',
        KEKSPAY: 'KEKS_PAY',
        PAYPAL: 'PAYPAL',
        DOWNLOAD: 'DOWNLOAD',
    };
    FinanceInvoice.CurrencyEnum = {
        HRK: 'HRK',
        EUR: 'EUR',
    };
    FinanceInvoice.FiscalizationEnum = {
        IsFiscalised: 'is_fiscalised',
        NotFiscalised: 'not_fiscalised',
        DoesntNeedFiscalization: 'doesnt_need_fiscalization',
    };
    FinanceInvoice.StatusEnum = {
        New: 'new',
        Checked: 'checked',
        ReadyForSap: 'ready_for_sap',
        TransferedToSap: 'transfered_to_sap',
        NotForSap: 'not_for_sap',
    };
})(FinanceInvoice || (FinanceInvoice = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var FinanceInvoiceStatusRequest;
(function (FinanceInvoiceStatusRequest) {
    FinanceInvoiceStatusRequest.StatusEnum = {
        New: 'new',
        Checked: 'checked',
        ReadyForSap: 'ready_for_sap',
        TransferedToSap: 'transfered_to_sap',
        NotForSap: 'not_for_sap',
    };
})(FinanceInvoiceStatusRequest || (FinanceInvoiceStatusRequest = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var Gallery;
(function (Gallery) {
    Gallery.PublishStateEnum = {
        NOTPUBLISHED: 'NOT_PUBLISHED',
        PUBLISHED: 'PUBLISHED',
        AUTOPUBLISHAFTERDATE: 'AUTO_PUBLISH_AFTER_DATE',
    };
})(Gallery || (Gallery = {}));

var GalleryGroupItem;
(function (GalleryGroupItem) {
    GalleryGroupItem.PublishStateEnum = {
        NOTPUBLISHED: 'NOT_PUBLISHED',
        PUBLISHED: 'PUBLISHED',
        AUTOPUBLISHAFTERDATE: 'AUTO_PUBLISH_AFTER_DATE',
    };
})(GalleryGroupItem || (GalleryGroupItem = {}));

var HomepageBlock;
(function (HomepageBlock) {
    HomepageBlock.BlockTypeEnum = {
        LAYOUTA: 'LAYOUT_A',
        LAYOUTB: 'LAYOUT_B',
        LAYOUTC: 'LAYOUT_C',
        LAYOUTD: 'LAYOUT_D',
        LAYOUTE: 'LAYOUT_E',
        LAYOUTF: 'LAYOUT_F',
        LAYOUTG: 'LAYOUT_G',
        CONTENTPRODUCTION: 'CONTENT_PRODUCTION',
        CONTENTVIDEO: 'CONTENT_VIDEO',
        CONTENTAGENCIES: 'CONTENT_AGENCIES',
        CONTENTCUSTOMORDERS: 'CONTENT_CUSTOM_ORDERS',
        CONTENTEDITORIAL: 'CONTENT_EDITORIAL',
        CONTENTAGEPHOTOSTOCK: 'CONTENT_AGEPHOTOSTOCK',
    };
})(HomepageBlock || (HomepageBlock = {}));

var HomepageBlockProductPreview;
(function (HomepageBlockProductPreview) {
    HomepageBlockProductPreview.KindEnum = {
        SINGLEPRODUCT: 'SINGLE_PRODUCT',
        GALLERY: 'GALLERY',
        GALLERYGROUP: 'GALLERY_GROUP',
    };
})(HomepageBlockProductPreview || (HomepageBlockProductPreview = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var Invoice;
(function (Invoice) {
    Invoice.StatusEnum = {
        PAID: 'PAID',
        UNPAID: 'UNPAID',
    };
    Invoice.PaymentMethodEnum = {
        CARD: 'CARD',
        KEKSPAY: 'KEKS_PAY',
        PAYPAL: 'PAYPAL',
        DOWNLOAD: 'DOWNLOAD',
    };
    Invoice.EuroModeEnum = {
        HRKONLY: 'HRK_ONLY',
        BIGHRKSMALLEUR: 'BIG_HRK_SMALL_EUR',
        BIGEURSMALLHRK: 'BIG_EUR_SMALL_HRK',
        EURONLY: 'EUR_ONLY',
    };
})(Invoice || (Invoice = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var MediaItem;
(function (MediaItem) {
    MediaItem.KindEnum = {
        PHOTO: 'PHOTO',
        VIDEO: 'VIDEO',
    };
})(MediaItem || (MediaItem = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var NewsletterStatus;
(function (NewsletterStatus) {
    NewsletterStatus.StatusEnum = {
        PRESENTED: 'PRESENTED',
        PRESENTEDANDCLOSED: 'PRESENTED_AND_CLOSED',
        SENTWITHSUCCESS: 'SENT_WITH_SUCCESS',
        SENTWITHFAILURE: 'SENT_WITH_FAILURE',
    };
})(NewsletterStatus || (NewsletterStatus = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var ProductItem;
(function (ProductItem) {
    ProductItem.KindEnum = {
        PHOTO: 'PHOTO',
        VIDEO: 'VIDEO',
    };
})(ProductItem || (ProductItem = {}));

var ProductPreview;
(function (ProductPreview) {
    ProductPreview.KindEnum = {
        SINGLEPRODUCT: 'SINGLE_PRODUCT',
        GALLERY: 'GALLERY',
        GALLERYGROUP: 'GALLERY_GROUP',
    };
})(ProductPreview || (ProductPreview = {}));

var ProductPriceCalculation;
(function (ProductPriceCalculation) {
    ProductPriceCalculation.AvailableVariationsEnum = {
        PRINT: 'PRINT',
        WEB: 'WEB',
        VIDEO: 'VIDEO',
    };
    ProductPriceCalculation.DownloadOptionsEnum = {
        AUTHORSIGNATURE: 'AUTHOR_SIGNATURE',
        DOWNLOAD: 'DOWNLOAD',
        SENDTOSYSTEM: 'SEND_TO_SYSTEM',
        SENDTOCMS: 'SEND_TO_CMS',
        ADDTOCART: 'ADD_TO_CART',
        DOWNLOADEXAMPLE: 'DOWNLOAD_EXAMPLE',
    };
})(ProductPriceCalculation || (ProductPriceCalculation = {}));

var ProductUpdateItem;
(function (ProductUpdateItem) {
    ProductUpdateItem.KindEnum = {
        PHOTO: 'PHOTO',
        VIDEO: 'VIDEO',
    };
})(ProductUpdateItem || (ProductUpdateItem = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var PushNotificationTokenRegistration;
(function (PushNotificationTokenRegistration) {
    PushNotificationTokenRegistration.PlatformEnum = {
        WEB: 'WEB',
    };
})(PushNotificationTokenRegistration || (PushNotificationTokenRegistration = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var RegistrationRequest;
(function (RegistrationRequest) {
    RegistrationRequest.KindEnum = {
        SMALL: 'SMALL',
        CORPORATE: 'CORPORATE',
    };
})(RegistrationRequest || (RegistrationRequest = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var SubportalFilterResponse;
(function (SubportalFilterResponse) {
    SubportalFilterResponse.AvailableFilterIntervalEnum = {
        ALL: 'ALL',
        PAST24H: 'PAST_24H',
        PAST48H: 'PAST_48H',
        RANGE: 'RANGE',
    };
    SubportalFilterResponse.AvailableFilterKindEnum = {
        VIDEO: 'VIDEO',
        PHOTO: 'PHOTO',
    };
    SubportalFilterResponse.AvailableFilterOrientationEnum = {
        HORIZONTAL: 'HORIZONTAL',
        VERTICAL: 'VERTICAL',
        SQUARE: 'SQUARE',
    };
    SubportalFilterResponse.AvailableFilterColourEnum = {
        COLOUR: 'COLOUR',
        GRAYSCALE: 'GRAYSCALE',
    };
})(SubportalFilterResponse || (SubportalFilterResponse = {}));

var Tag;
(function (Tag) {
    Tag.StatusEnum = {
        ACTIVE: 'ACTIVE',
        INACTIVE: 'INACTIVE',
    };
})(Tag || (Tag = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var Translatable;
(function (Translatable) {
    Translatable.LanguageEnum = {
        HR: 'HR',
        EN: 'EN',
        SI: 'SI',
        DE: 'DE',
        IT: 'IT',
    };
})(Translatable || (Translatable = {}));

var UpdateDownload;
(function (UpdateDownload) {
    UpdateDownload.CurrencyEnum = {
        HRK: 'HRK',
        EUR: 'EUR',
    };
})(UpdateDownload || (UpdateDownload = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var UploadSessionPublishRequest;
(function (UploadSessionPublishRequest) {
    UploadSessionPublishRequest.KindEnum = {
        SAVE: 'SAVE',
        PUBLISH: 'PUBLISH',
    };
})(UploadSessionPublishRequest || (UploadSessionPublishRequest = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

var User;
(function (User) {
    User.KindEnum = {
        SMALL: 'SMALL',
        CORPORATE: 'CORPORATE',
    };
    User.CurrencyNameEnum = {
        HRK: 'HRK',
        EUR: 'EUR',
        USD: 'USD',
        GBP: 'GBP',
    };
    User.DownloadTypePremissionsEnum = {
        PHOTO: 'PHOTO',
        PHOTOLARGE: 'PHOTO_LARGE',
        PHOTOLARGESIGNATURE: 'PHOTO_LARGE_SIGNATURE',
        PHOTOSMALL: 'PHOTO_SMALL',
        PHOTOSMALLSIGNATURE: 'PHOTO_SMALL_SIGNATURE',
        VIDEO: 'VIDEO',
    };
    User.StateEnum = {
        ACTIVE: 'ACTIVE',
        INACTIVE: 'INACTIVE',
    };
    User.UserPermissionsEnum = {
        FAFPREAD: 'F_AFP_READ',
        FAGENCIESREAD: 'F_AGENCIES_READ',
        FREUTERSREAD: 'F_REUTERS_READ',
        FSTOCKREAD: 'F_STOCK_READ',
        FGIRLOFDAYREAD: 'F_GIRL_OF_DAY_READ',
        SUPERADMIN: 'SUPERADMIN',
        DEVELOPER: 'DEVELOPER',
        IMPORTREAD: 'IMPORT_READ',
        IMPORTEDIT: 'IMPORT_EDIT',
        IMPORTCREATE: 'IMPORT_CREATE',
        IMPORTDELETE: 'IMPORT_DELETE',
        CPRODUCTSREAD: 'C_PRODUCTS_READ',
        CPRODUCTSEDIT: 'C_PRODUCTS_EDIT',
        CPRODUCTSCREATE: 'C_PRODUCTS_CREATE',
        CPRODUCTSDELETE: 'C_PRODUCTS_DELETE',
        CGALLERIESREAD: 'C_GALLERIES_READ',
        CGALLERIESEDIT: 'C_GALLERIES_EDIT',
        CGALLERIESCREATE: 'C_GALLERIES_CREATE',
        CGALLERIESDELETE: 'C_GALLERIES_DELETE',
        CGALLERIESPUBLISH: 'C_GALLERIES_PUBLISH',
        CGALLERYGROUPSREAD: 'C_GALLERY_GROUPS_READ',
        CGALLERYGROUPSEDIT: 'C_GALLERY_GROUPS_EDIT',
        CGALLERYGROUPSCREATE: 'C_GALLERY_GROUPS_CREATE',
        CGALLERYGROUPSDELETE: 'C_GALLERY_GROUPS_DELETE',
        CGALLERYGROUPSPUBLISH: 'C_GALLERY_GROUPS_PUBLISH',
        CARTICLESREAD: 'C_ARTICLES_READ',
        CARTICLESEDIT: 'C_ARTICLES_EDIT',
        CARTICLESCREATE: 'C_ARTICLES_CREATE',
        CARTICLESDELETE: 'C_ARTICLES_DELETE',
        CARTICLESPUBLISH: 'C_ARTICLES_PUBLISH',
        CCATEGORIESREAD: 'C_CATEGORIES_READ',
        CCATEGORIESEDIT: 'C_CATEGORIES_EDIT',
        CCATEGORIESCREATE: 'C_CATEGORIES_CREATE',
        CCATEGORIESDELETE: 'C_CATEGORIES_DELETE',
        CCATEGORIESPUBLISH: 'C_CATEGORIES_PUBLISH',
        NEWSLETTERREAD: 'NEWSLETTER_READ',
        NEWSLETTEREDIT: 'NEWSLETTER_EDIT',
        NEWSLETTERCREATE: 'NEWSLETTER_CREATE',
        NEWSLETTERDELETE: 'NEWSLETTER_DELETE',
        UCCOMPANIESREAD: 'UC_COMPANIES_READ',
        UCCOMPANIESEDIT: 'UC_COMPANIES_EDIT',
        UCCOMPANIESCREATE: 'UC_COMPANIES_CREATE',
        UCCOMPANIESDELETE: 'UC_COMPANIES_DELETE',
        UCUSERSREAD: 'UC_USERS_READ',
        UCUSERSEDIT: 'UC_USERS_EDIT',
        UCUSERSCREATE: 'UC_USERS_CREATE',
        UCUSERSDELETE: 'UC_USERS_DELETE',
        UCDOWNLOADSREAD: 'UC_DOWNLOADS_READ',
        UCDOWNLOADSEDIT: 'UC_DOWNLOADS_EDIT',
        UCDOWNLOADSCREATE: 'UC_DOWNLOADS_CREATE',
        UCDOWNLOADSDELETE: 'UC_DOWNLOADS_DELETE',
        UCCONTRACTSREAD: 'UC_CONTRACTS_READ',
        UCCONTRACTSEDIT: 'UC_CONTRACTS_EDIT',
        UCCONTRACTSCREATE: 'UC_CONTRACTS_CREATE',
        UCCONTRACTSDELETE: 'UC_CONTRACTS_DELETE',
        UCINVOICESREAD: 'UC_INVOICES_READ',
        UCINVOICESEDIT: 'UC_INVOICES_EDIT',
        UCINVOICESCREATE: 'UC_INVOICES_CREATE',
        UCINVOICESDELETE: 'UC_INVOICES_DELETE',
        DAAGENCIESREAD: 'DA_AGENCIES_READ',
        DAAGENCIESEDIT: 'DA_AGENCIES_EDIT',
        DAAGENCIESCREATE: 'DA_AGENCIES_CREATE',
        DAAGENCIESDELETE: 'DA_AGENCIES_DELETE',
        DAIPTCREAD: 'DA_IPTC_READ',
        DAIPTCEDIT: 'DA_IPTC_EDIT',
        DAIPTCCREATE: 'DA_IPTC_CREATE',
        DAIPTCDELETE: 'DA_IPTC_DELETE',
        DAKEYWORDSREAD: 'DA_KEYWORDS_READ',
        DAKEYWORDSEDIT: 'DA_KEYWORDS_EDIT',
        DAKEYWORDSCREATE: 'DA_KEYWORDS_CREATE',
        DAKEYWORDSDELETE: 'DA_KEYWORDS_DELETE',
        DAPROPERNAMESREAD: 'DA_PROPER_NAMES_READ',
        DAPROPERNAMESEDIT: 'DA_PROPER_NAMES_EDIT',
        DAPROPERNAMESCREATE: 'DA_PROPER_NAMES_CREATE',
        DAPROPERNAMESDELETE: 'DA_PROPER_NAMES_DELETE',
        DATAGSREAD: 'DA_TAGS_READ',
        DATAGSEDIT: 'DA_TAGS_EDIT',
        DATAGSCREATE: 'DA_TAGS_CREATE',
        DATAGSDELETE: 'DA_TAGS_DELETE',
        DAPHOTOREPORTERSREAD: 'DA_PHOTOREPORTERS_READ',
        DAPHOTOREPORTERSEDIT: 'DA_PHOTOREPORTERS_EDIT',
        DAPHOTOREPORTERSCREATE: 'DA_PHOTOREPORTERS_CREATE',
        DAPHOTOREPORTERSDELETE: 'DA_PHOTOREPORTERS_DELETE',
        WAHOMEREAD: 'WA_HOME_READ',
        WAHOMEEDIT: 'WA_HOME_EDIT',
        WAHOMECREATE: 'WA_HOME_CREATE',
        WAHOMEDELETE: 'WA_HOME_DELETE',
        WAHOMEPUBLISH: 'WA_HOME_PUBLISH',
        WAABOUTUSREAD: 'WA_ABOUT_US_READ',
        WAABOUTUSEDIT: 'WA_ABOUT_US_EDIT',
        WAABOUTUSCREATE: 'WA_ABOUT_US_CREATE',
        WAABOUTUSDELETE: 'WA_ABOUT_US_DELETE',
        WAABOUTUSPUBLISH: 'WA_ABOUT_US_PUBLISH',
        WACONTENTPAGESREAD: 'WA_CONTENT_PAGES_READ',
        WACONTENTPAGESEDIT: 'WA_CONTENT_PAGES_EDIT',
        WACONTENTPAGESCREATE: 'WA_CONTENT_PAGES_CREATE',
        WACONTENTPAGESDELETE: 'WA_CONTENT_PAGES_DELETE',
        WACONTENTPAGESPUBLISH: 'WA_CONTENT_PAGES_PUBLISH',
        WASTATICPAGESREAD: 'WA_STATIC_PAGES_READ',
        WASTATICPAGESEDIT: 'WA_STATIC_PAGES_EDIT',
        WASTATICPAGESCREATE: 'WA_STATIC_PAGES_CREATE',
        WASTATICPAGESDELETE: 'WA_STATIC_PAGES_DELETE',
        WASTATICPAGESPUBLISH: 'WA_STATIC_PAGES_PUBLISH',
        FINPRODUCTDOWNLOADSREAD: 'FIN_PRODUCT_DOWNLOADS_READ',
        FINPRODUCTDOWNLOADSEDIT: 'FIN_PRODUCT_DOWNLOADS_EDIT',
        FINPRODUCTDOWNLOADSCREATE: 'FIN_PRODUCT_DOWNLOADS_CREATE',
        FINPRODUCTDOWNLOADSDELETE: 'FIN_PRODUCT_DOWNLOADS_DELETE',
        FINADMINISTRATIONREAD: 'FIN_ADMINISTRATION_READ',
        FINADMINISTRATIONEDIT: 'FIN_ADMINISTRATION_EDIT',
        FINADMINISTRATIONCREATE: 'FIN_ADMINISTRATION_CREATE',
        FINADMINISTRATIONDELETE: 'FIN_ADMINISTRATION_DELETE',
        FINDISCOUNTREAD: 'FIN_DISCOUNT_READ',
        FINDISCOUNTEDIT: 'FIN_DISCOUNT_EDIT',
        FINDISCOUNTCREATE: 'FIN_DISCOUNT_CREATE',
        FINDISCOUNTDELETE: 'FIN_DISCOUNT_DELETE',
        FININVOICESREAD: 'FIN_INVOICES_READ',
        FININVOICESEDIT: 'FIN_INVOICES_EDIT',
        FININVOICESCREATE: 'FIN_INVOICES_CREATE',
        FININVOICESDELETE: 'FIN_INVOICES_DELETE',
        STATISTICSREAD: 'STATISTICS_READ',
        STATISTICSEDIT: 'STATISTICS_EDIT',
        STATISTICSCREATE: 'STATISTICS_CREATE',
        STATISTICSDELETE: 'STATISTICS_DELETE',
        IUINTERNALUSERSREAD: 'IU_INTERNAL_USERS_READ',
        IUINTERNALUSERSEDIT: 'IU_INTERNAL_USERS_EDIT',
        IUINTERNALUSERSCREATE: 'IU_INTERNAL_USERS_CREATE',
        IUINTERNALUSERSDELETE: 'IU_INTERNAL_USERS_DELETE',
        IUUSERGROUPSREAD: 'IU_USER_GROUPS_READ',
        IUUSERGROUPSEDIT: 'IU_USER_GROUPS_EDIT',
        IUUSERGROUPSCREATE: 'IU_USER_GROUPS_CREATE',
        IUUSERGROUPSDELETE: 'IU_USER_GROUPS_DELETE',
        IUUSERLOGINLOGREAD: 'IU_USER_LOGIN_LOG_READ',
        IUUSERLOGINLOGEDIT: 'IU_USER_LOGIN_LOG_EDIT',
        IUUSERLOGINLOGCREATE: 'IU_USER_LOGIN_LOG_CREATE',
        IUUSERLOGINLOGDELETE: 'IU_USER_LOGIN_LOG_DELETE',
        ACTIVITYLOGREAD: 'ACTIVITY_LOG_READ',
        ACTIVITYLOGEDIT: 'ACTIVITY_LOG_EDIT',
        ACTIVITYLOGCREATE: 'ACTIVITY_LOG_CREATE',
        ACTIVITYLOGDELETE: 'ACTIVITY_LOG_DELETE',
        CONTACTFORMREAD: 'CONTACT_FORM_READ',
        CONTACTFORMEDIT: 'CONTACT_FORM_EDIT',
        CONTACTFORMCREATE: 'CONTACT_FORM_CREATE',
        CONTACTFORMDELETE: 'CONTACT_FORM_DELETE',
    };
})(User || (User = {}));

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.36
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class UsersService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    getUser(user_id, observe = 'body', reportProgress = false) {
        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling getUser.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/user/${encodeURIComponent(String(user_id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    postUser(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/user`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    putUser(user_id, body, observe = 'body', reportProgress = false) {
        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling putUser.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = ['application/json'];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('put', `${this.basePath}/user/${encodeURIComponent(String(user_id))}`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
UsersService.ɵfac = function UsersService_Factory(t) { return new (t || UsersService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
UsersService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: UsersService, factory: UsersService.ɵfac });
UsersService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UsersService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();

function escapeStringWindows(str) {
    return ('"' +
        str
            .replace(/"/g, '""')
            .replace(/%/g, '"%"')
            .replace(/\\/g, '\\\\')
            .replace(/[\r\n]+/g, '"^$&"') +
        '"');
}
function escapeStringPosix(str) {
    function escapeCharacter(x) {
        let code = x.charCodeAt(0);
        if (code < 256) {
            // Add leading zero when needed to not care about the next character.
            return code < 16 ? '\\x0' + code.toString(16) : '\\x' + code.toString(16);
        }
        let codeStr = code.toString(16);
        return '\\u' + ('0000' + codeStr).substr(codeStr.length, 4);
    }
    if (/[^\x20-\x7E]|\'/.test(str)) {
        // Use ANSI-C quoting syntax.
        return ("$'" +
            str
                .replace(/\\/g, '\\\\')
                .replace(/\'/g, "\\'")
                .replace(/\n/g, '\\n')
                .replace(/\r/g, '\\r')
                .replace(/[^\x20-\x7E]/g, escapeCharacter) +
            "'");
    }
    else {
        // Use single quote syntax.
        return "'" + str + "'";
    }
}
function toCurl(request) {
    let platform = 'posix';
    let url = new URL(request.url);
    let method = request.method;
    let path = url.pathname;
    let command = ['curl'], ignoredHeaders = ['host', 'method', 'path', 'scheme', 'version'], escapeString = platform === 'win' ? escapeStringWindows : escapeStringPosix, requestMethod = 'GET', data = [], requestHeaders = request.headers, requestBody = request.serializeBody(), contentType = requestHeaders.get('content-type');
    console.debug('Request headers', requestHeaders);
    command.push(escapeString(request.url).replace(/[[{}\]]/g, '\\$&'));
    if (requestBody !== null && requestBody !== '') {
        ignoredHeaders.push('content-length');
        requestMethod = 'POST';
        if (contentType &&
            contentType.startsWith('application/x-www-form-urlencoded')) {
            data.push('--data');
        }
        else {
            data.push('--data-binary');
        }
        data.push(escapeString(requestBody));
    }
    if (method !== requestMethod) {
        command.push('-X');
        command.push(method);
    }
    requestHeaders
        .keys()
        .filter((name) => ignoredHeaders.indexOf(name) === -1)
        .forEach(function (name) {
        command.push('-H');
        command.push(escapeString(name.replace(/^:/, '') + ': ' + requestHeaders.get(name)));
    });
    command = command.concat(data);
    command.push('--compressed');
    return command.join(' ');
}

class Interceptor {
    constructor(configuration, apiHandler, basePath, version) {
        this.configuration = configuration;
        this.apiHandler = apiHandler;
        this.basePath = basePath;
        this.version = version;
    }
    intercept(req, next) {
        let accessTokenValue;
        if (this.apiHandler) {
            accessTokenValue = this.apiHandler.getAccessToken();
        }
        let headers = new HttpHeaders();
        headers = headers.set('Accept-Language', this.apiHandler.getLanguage());
        headers = headers.set('X-Pixsell-Language', this.apiHandler.getLanguage());
        headers = headers.set('X-Pixsell-Version', this.version);
        if (accessTokenValue != undefined) {
            headers = headers.set('Authorization', 'Bearer ' + accessTokenValue);
            const modifiedRequest = req.clone({ headers });
            return next.handle(modifiedRequest).pipe(tap((_) => { }, (error) => {
                var _a, _b, _c;
                let errorOutput = '\n=============================================\n' +
                    'REQUEST FAILED\n' +
                    '=============================================\n\n\n';
                const curlRequest = toCurl(modifiedRequest);
                errorOutput += 'Request:\n' + curlRequest + '\n\n';
                console.debug('Request failed', error);
                if (error.error instanceof ErrorEvent) {
                    // A client-side or network error occurred. Handle it accordingly.
                    errorOutput += 'An error occurred:' + error.error.message + '\n';
                }
                else {
                    // The backend returned an unsuccessful response code.
                    // The response body may contain clues as to what went wrong,
                    errorOutput +=
                        `Backend returned code ${error.status}, ` +
                            `body was:\n\n${error.error}` +
                            '\n';
                    if (error.status === 401) {
                        if (error.error != undefined) {
                            let errorResponse = error.error;
                            if (errorResponse.message != undefined) {
                                (_a = this.apiHandler) === null || _a === void 0 ? void 0 : _a.handleUnauthenticated(errorResponse.message);
                            }
                            else {
                                (_b = this.apiHandler) === null || _b === void 0 ? void 0 : _b.handleUnauthenticated(undefined);
                            }
                        }
                        else {
                            (_c = this.apiHandler) === null || _c === void 0 ? void 0 : _c.handleUnauthenticated(undefined);
                        }
                        return;
                    }
                }
                errorOutput += '\n\n';
                console.debug(errorOutput);
            }));
        }
        const modifiedRequest = req.clone({ headers });
        return next.handle(modifiedRequest).pipe(tap((_) => { }, (error) => {
            var _a, _b, _c;
            let errorOutput = '\n=============================================\n' +
                'REQUEST FAILED\n' +
                '=============================================\n\n\n';
            const curlRequest = toCurl(req);
            errorOutput += 'Request:\n' + curlRequest + '\n\n';
            console.debug('Request failed', error);
            if (error.error instanceof ErrorEvent) {
                // A client-side or network error occurred. Handle it accordingly.
                errorOutput += 'An error occurred:' + error.error.message + '\n';
            }
            else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                errorOutput +=
                    `Backend returned code ${error.status}, ` +
                        `body was:\n\n${error.error}` +
                        '\n';
                if (error.status === 401) {
                    if (error.error != undefined) {
                        let errorResponse = error.error;
                        if (errorResponse.message != undefined) {
                            (_a = this.apiHandler) === null || _a === void 0 ? void 0 : _a.handleUnauthenticated(errorResponse.message);
                        }
                        else {
                            (_b = this.apiHandler) === null || _b === void 0 ? void 0 : _b.handleUnauthenticated(undefined);
                        }
                    }
                    else {
                        (_c = this.apiHandler) === null || _c === void 0 ? void 0 : _c.handleUnauthenticated(undefined);
                    }
                    return;
                }
            }
            errorOutput += '\n\n';
            console.debug(errorOutput);
        }));
    }
}
Interceptor.ɵfac = function Interceptor_Factory(t) { return new (t || Interceptor)(ɵngcc0.ɵɵinject(Configuration, 8), ɵngcc0.ɵɵinject(API_HANDLER, 8), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(VERSION, 8)); };
Interceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: Interceptor, factory: Interceptor.ɵfac });
Interceptor.ctorParameters = () => [
    { type: Configuration, decorators: [{ type: Optional }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [API_HANDLER,] }] },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [VERSION,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Interceptor, [{
        type: Injectable
    }], function () { return [{ type: Configuration, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [API_HANDLER]
            }] }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VERSION]
            }] }]; }, null); })();

class ApiModule {
    constructor(parentModule, http) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575');
        }
    }
    static forRoot(configurationFactory) {
        return {
            ngModule: ApiModule,
            providers: [{ provide: Configuration, useFactory: configurationFactory }],
        };
    }
}
ApiModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ApiModule });
ApiModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ApiModule_Factory(t) { return new (t || ApiModule)(ɵngcc0.ɵɵinject(ApiModule, 12), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient, 8)); }, providers: [
        DynamicViewsService,
        AgenciesService,
        AuthorsService,
        AutocompleteService,
        CMSService,
        CMSGalleriesService,
        CMSUsersService,
        CMSCompaniesService,
        CMSContractsService,
        CartService,
        CategoriesService,
        FrontGalleriesService,
        GalleryGroupsService,
        HomepageService,
        IPTCService,
        KeywordsService,
        LicenceTypesService,
        PeopleService,
        ProductsService,
        ProductsFrontService,
        ProfileService,
        ProperNameService,
        RegistrationLoginService,
        SpecialInstructionsService,
        SpecialOfferTypesService,
        TagsService,
        InternalUsersService,
        FrontPushNotificationsService,
        UploadSessionsService,
        { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
        UserRightsService,
        UsersService,
        WebAdministrationService,
        SettingsService,
    ], imports: [[]] });
ApiModule.ctorParameters = () => [
    { type: ApiModule, decorators: [{ type: Optional }, { type: SkipSelf }] },
    { type: HttpClient, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApiModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                exports: [],
                providers: [
                    DynamicViewsService,
                    AgenciesService,
                    AuthorsService,
                    AutocompleteService,
                    CMSService,
                    CMSGalleriesService,
                    CMSUsersService,
                    CMSCompaniesService,
                    CMSContractsService,
                    CartService,
                    CategoriesService,
                    FrontGalleriesService,
                    GalleryGroupsService,
                    HomepageService,
                    IPTCService,
                    KeywordsService,
                    LicenceTypesService,
                    PeopleService,
                    ProductsService,
                    ProductsFrontService,
                    ProfileService,
                    ProperNameService,
                    RegistrationLoginService,
                    SpecialInstructionsService,
                    SpecialOfferTypesService,
                    TagsService,
                    InternalUsersService,
                    FrontPushNotificationsService,
                    UploadSessionsService,
                    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
                    UserRightsService,
                    UsersService,
                    WebAdministrationService,
                    SettingsService,
                ]
            }]
    }], function () { return [{ type: ApiModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }, { type: ɵngcc1.HttpClient, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { APIS, API_HANDLER, AddToCart, AgenciesService, Agency, AgencyIpctTag, ApiModule, AuthorsService, AutocompleteService, BASE_PATH, BlockTypeBlock, BlockTypeSection, CMSCompaniesService, CMSContractsService, CMSGalleriesService, CMSService, CMSUsersService, COLLECTION_FORMATS, Cart, CartLine, CartPaymentGatewayRequest, CartPaymentGatewayResponse, CartPaymentRequest, CartService, CategoriesService, CmsEditingCompany, CmsEditingUser, Company, Configuration, Contract, ContractLine, Download, DynamicView, DynamicViewField, DynamicViewValidation, DynamicViewsService, FinanceInvoice, FinanceInvoiceStatusRequest, FrontGalleriesService, FrontPushNotificationsService, Gallery, GalleryGroupItem, GalleryGroupsService, HomepageBlock, HomepageBlockProductPreview, HomepageService, IPTCService, InternalUsersService, Invoice, KeywordsService, LicenceTypesService, MediaItem, NewsletterStatus, PeopleService, ProductItem, ProductPreview, ProductPriceCalculation, ProductUpdateItem, ProductsFrontService, ProductsService, ProfileService, ProperNameService, PushNotificationTokenRegistration, RegistrationLoginService, RegistrationRequest, SettingsService, SpecialInstructionsService, SpecialOfferTypesService, SubportalFilterResponse, Tag, TagsService, Translatable, UpdateDownload, UploadSessionPublishRequest, UploadSessionsService, User, UserRightsService, VERSION, WebAdministrationService, Interceptor as ɵa, UsersService as ɵb };

//# sourceMappingURL=piwe-front-swagger-client.js.map